import React, { useState, useEffect, useRef, useCallback } from "react";
import { connect, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import { setUserDetails } from "../redux/actions/userAction";
import HttpService from "../services/httpService";
import moment from "moment";
import { commaSeparateAmount } from "../components/commaSeparate";
import { CSVLink } from "react-csv";
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CardPineLabsPmtPrev from '../assets/img/org/CardPineLabsPmtPrev.jpeg'
import BankTransfersVirtualAccountPmtPrev from '../assets/img/org/BankTransfersVirtualAccountPmtPrev.jpeg'
import BankTransfersNonVirtualAccountPmtPrev from '../assets/img/org/BankTransfersNonVirtualAccountPmtPrev.jpeg'
import UPIpmtPrev from '../assets/img/org/UPIpmtPrev.jpeg'
import CashPmtPrev from '../assets/img/org/CashPmtPrev.jpeg'
import ChequePmtPrev from '../assets/img/org/ChequePmtPrev.jpeg'
import CreditFairPmtPrev from '../assets/img/org/CreditFairPmtPrev.jpeg'
import OthersPmtPrev from '../assets/img/org/OthersPmtPrev.jpeg'
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import {
  Table, TableBody, TextField, TableCell, TableContainer, TableHead, TableRow, Paper, Button, FormControl, MenuItem, FormControlLabel, Switch, Checkbox,
  InputLabel, Select, DialogContentText, DialogContent, Divider, DialogTitle, Dialog, DialogActions, Radio
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import RadioGroup from '@material-ui/core/RadioGroup';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Typography, CircularProgress, Box } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EditIcon from '@material-ui/icons/Edit';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { FileExcelOutlined, DownloadOutlined } from '@ant-design/icons';
import { constantUnitTypeMaster, constantPlyTypeMaster, constantDepartmentId, ROLENAME, rftUnitTypeId, cutoffDate, allowedDepartments, excludedStages } from '../utils/index';
import decorpotLogo from '../assets/img/org/deco_new_logo.png'
import { FaArrowRight } from "react-icons/fa";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';


const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
  },
  root: {
    width: "100%",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  tableViewButton: {
    backgroundColor: "#b7ccf7",
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "30%",
    "&:hover": { backgroundColor: "#14419c", color: "white" },
  },
  leadSearchButton: {
    backgroundColor: "#FDB913",
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
    "&:hover": { backgroundColor: "#14419c", color: "white" },
  },
  initiatePaymentButton : { backgroundColor: 'white', color: '#1a542e', padding: '1', marginRight: '0.5em', marginLeft: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#1a542e", color: 'white' } },
  recordPaymentButton : { backgroundColor: 'white', color: '#14419c', padding: '1', marginRight: '0.5em', marginLeft: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#14419c", color: 'white' } },

  yesButton: { backgroundColor: 'white', color: '#14419c', padding: '1', marginRight: '0.5em', marginLeft: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#14419c", color: 'white' } },
  noButton: { backgroundColor: 'white', color: '#151921', padding: '1', marginRight: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#151921", color: 'white' } },
  previewButton: { backgroundColor: 'white', color: '#14419c', padding: '1', marginRight: '0.5em', marginLeft: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#14419c", color: 'white' }, width: '40%' },

}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#ccc",
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const RaiseQuotationChangeRequest = (props) => {
  const classes = useStyles();
  const { userDetails } = useSelector((state) => state.user);
  const [qtprojects, setQTProjectRows] = useState([]);
  const [searched, setSearched] = useState("");
  const [usersData, setUsersData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [selectedSearchType, setSelectedSearchType] = useState([]);
  const [leadId, setLeadId] = useState("");
  const [sourceOfLeadData, setSourceOfLeadData] = useState([]);
  const [projectDetails, setProjectDetails] = useState({});
  const [departmentList, setDepartmentList] = useState([]);
  const buttonRef = useRef(null);

  const [value, setValue] = useState(null);
  const [totalPaymentPrice, setTotalPaymentPrice] = useState(0);
  const [totalDescPerAmt, setTotalDescPerAmt] = useState(0);
  const [totalNonDescPerAmt, setTotalNonDescPerAmt] = useState(0);
  const [discount, setChangeDiscount] = useState(0);
  const [discountMaster, setDiscountMaster] = useState(0);
  const [discountMasterMax, setDiscountMasterMax] = useState(0);
  const [discountMasterMaxApr26, setDiscountMasterMaxApr26] = useState(0);
  const [discountItemSubTotal, setDiscountItemSubTotal] = useState(0)
  const [chosenCategory, setChosenCategory] = useState("")
  const [chosenCategoryId, setChosenCategoryId] = useState("")
  const [eligibleDiscountScopes, setEligibleDiscountScopes] = useState('');
  const [eligibleNonDiscountScopes, setEligibleNonDiscountScopes] = useState('');
  const [selectedQuotationVersion, setSelectedQuotationVersion] = useState('')
  const [selectedCatergory, setSelectedCatergory] = useState({})
  const [laminateObj, setLaminateObj] = useState({})
  const [projectComponentProducts, setProjectComponentProducts] = useState({})
  const [defaultPlyType, setDefaultPlyType] = useState({});
  const [paymentTotalInfo, setPaymentTotalInfo] = useState({});
  const [prevQtTotalAmount, setPrevQtTotalAmount] = useState(0);
  const [diffQtChanges, setDiffQtChanges] = useState(0);
  const [qtPreviewOnlyNewData, setqtPreviewOnlyNewData] = useState();
  const [projectDetailsFields, setProjectDetailsFields] = useState({
    name: "",
    email: "",
    contact_no: "",
    projectType: "",
    propertyType: "",
    scopeOfWork: "",
    description: "",
    floorPlan: "",
    isRegistered: "",
    area: "",
    leadType: "",
    discountOnAllScopes: "",
    assignTo: "",
    assignToManager: ""
  })
  const [isFileUploaded, setIsFileUploaded] = useState(false)
  const [startLoading, setStartLoading] = useState(false);
  const [paymentInitiated, setPaymentInitiated] = useState(false);
  const [defaultUnitType, setDefaultUnitType] = useState([])
  const [projectComponents, setProjectComponents] = useState([])
  const [quotationList, setQuotationList] = useState([])

  const [csvData, setCsvData] = useState([]);
  const [header, setHeaders] = useState([])
  const [categoryList, setCategoryList] = useState([])
  const [productsList, setProductsList] = useState([])
  const [finshesList, setFinishesList] = useState([])
  const [selectedFinish, setSelectedFinish] = useState([])
  const [plyList, setPlyList] = useState([])
  const [selectedRoomPly, setSelectedRoomPly] = useState([])
  const [qtPreview, setQtPreview] = useState([]);
  const [newItemAddedArray, setNewItemAddedArray] = useState([]);
  const [discountScopes, setDiscountScopes] = useState([]);
  const [nonDiscountScopes, setNonDiscountScopes] = useState([]);
  const [categoryspecificTotal, setCategoryspecificTotal] = useState([]);
  const [disCountEligibleItemsPriceAmount, setDisCountEligibleItemsPriceAmount] = useState([]);
  const [disCountNonEligibleItemsPriceAmount, setDisCountNonEligibleItemsPriceAmount] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState([]);
  const [showCreateQuotationModal, setShowCreateQuotationModal] = useState(false)
  const [leadInOutOfDesignStage, setLeadInOutOfDesignStage] = useState(false)
  const [serviceItemFlag, setServiceItemFlag] = useState(false)
  const [openPreviewModal, setOpenPreviewModal] = useState(false);
  const [editProjectModal, setEditProjectModal] = useState(false)
  const [openSelectQuotationVersion, setOpenSelectQuotationVersion] = useState(false);
  const [openPaymentCheckoutModal, setOpenPaymentCheckoutModal] = useState(false)
  const [paymentActionChosen, setPaymentActionChosen] = useState('Record');
  const [pineLabsPos, setPineLabsPos] = useState([]);
  const [selectedPosMachine, setSelectedPosMachine] = useState([])

  const [otherPaymentMethod, setOtherPaymentMethod] = useState({ slip_no: "", trxId: "", cheQueNo: "", other_txn_type: "", attachment: null })
  const [process, setProcess] = useState("")
  const [erpProjectNo, setErpProjectNo] = useState("")
  const [storeTenPercentAmount, setStoreTenPercentAmount] = useState({ amount: 0 });
  const [completedPayment, setCompletedPayment] = useState(false);
  const [plutusTransactionReferenceID, setPlutusTransactionReferenceID] = useState(0);
  const [paymentModes, setpaymentModes] = useState([]);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState([]);
  const [selectedNovVirtualBank, setSelectedNovVirtualBank] = useState([])
  const [sequenceNumber, setSequenceNumber] = useState(0)
  const [checkTotoalQuotationValue, setTotalQuotationValue] = useState(0)
  const [hidePaymentModeInput, setHidePaymentModeInput] = useState(false)
  const [nonVirtualBanks, setNonVirtualBanks] = useState([{ name: 'ICICI' }, { name: 'BOI' }, { name: 'HDFC' }, { name: 'SBI' }])
  const [editQt, setEditQt] = useState(0);
  const [sendApprovalQtCrValue, setSendApprovalQtCrValue] = useState({
    valuesGreaterThan20k: false,
    valuesLessThan20k: false,
    allPositiveValues: false,
  })
  const [paymentReceipt, setPaymentReceipt] = useState("");
  const [paymentReceiptArray, setPaymentReceiptArray] = useState([]);
  const [addPaymentReceiptFileUploaded, setAddPaymentReceiptFileUploaded] = useState(false);
  const [complimentaryItemPresent, setComplimentaryItemPresent] = useState(false);
  const [complimentaryItemRevoked, setComplimentaryItemRevoked] = useState(false);
  const [complimentarySpaceChange, setComplimentarySpaceChange] = useState(false);
  const [sameItemQty, setSameItemQty] = useState(false);
  const [newComplimentaryItem, setNewComplimentaryItem] = useState(false);
  const [rejectedItem, setRejectedItem] = useState(false);
  const [rejectedItemDR, setRejectedItemDR] = useState(false);
  const [hasMismatch, setHasMismatch] = useState(false);
  const [uploadData, setUploadData] = useState([]);
  const [paymentReceiptModal, setPaymentReceiptModal] = useState(false);
  const [finalizeButtonVisibility, setFinalizeButtonVisibility] = useState(false);
  const [quotationTotalAmount, SetQuotationTotalAmount] = useState(0);
  const [uploadPaymentButtonVisibility, SetUploadPaymentButtonVisibility] = useState(false);
  const [sendForApprovalDisable, setSendForApprovalDisable] = useState(false);
  const [addDataState, setAddDataState] = useState([])
  const [newChangesTotalProductsPrice, setNewChangesTotalProductsPrice] = useState({
    totalQuotationValue: 0,
    discount: 0,
    subTotal: 0,
    gst18PerAmount: 0,
    total: 0
  });
  const [balanceSheetData, setBalanceSheetData] = useState({
    reviseQuotationValue: 0,
    discount: 0,
    subTotal: 0,
    GST: 0,
    total: 0,
    pendingDue: 0,
    prevQuotationValue: 0,
  })
  const [damageDelayOtherValue, setDamageDelayOtherValue] = useState({
    delayPenalityCheck: false,
    damagesCheck: false,
    goodWillDiscountCheck: false,
    otherCheck: false,
    referralBonusCheck: false,
    delayPenality: 0,
    damages: 0,
    goodWillDiscount: 0,
    other: 0,
    referralBonus: 0
  })
  const [delayToReferralCategoryTotal, setDelayToReferralCategoryTotal] = useState(0);
  const [totalValueBeforeAddCategory, setTotalValueBeforeAddCategory] = useState(0)
  const [addRemoveTotalValue, setAddRemoveTotalValue] = useState(0);
  const [balansheSheetQtTotalPrice, setBalansheSheetQtTotalPrice] = useState(0);
  const [amountPaid, setAmountPaid] = useState(0);
  const [compareMode, setCompareMode] = useState(false);
  const [selectedQuotations, setSelectedQuotations] = useState([]);
  const [comparisionPreview, setComparisionPreview] = useState(false);
  const [comapredData, setComparedData] = useState([])
  const [pdfLink, setPdfLink] = useState("")
  const [currentPage, setCurrentPage] = useState('view');
  const [defaultDimension, setDefaultDimension] = useState({'mm': 300, 'Sqft': 1})
  const [displayUploadReceiptMsg, setDisplayUploadReceiptMsg]  = useState(true);
  const [searchTypes, setSearchTypes] = useState([
    { name: "Customer Name" },
    { name: "Email ID" },
    { name: "Lead No" },
    { name: "Project No" },
    { name: "Contact No" },
    { name: "Unique Lead No" },
  ]);

function transform(value) {
  if (value === undefined) return ' ';
  let val = String(value);
  let finalval = '';
  let j = 0;
  let flag = 0;
  let isNegative = false;

  // Check if the value is negative
  if (val[0] === '-') {
    isNegative = true;
    val = val.slice(1);
  }
  for (let i = val.length - 1; i > -1; i--) {
    finalval = val[i] + finalval;
    j++;
    if (val[i] === '.') {
      j = 0;
    }

    if (j === 3 && i !== 0) {
      finalval = ',' + finalval;
      j = 0;
      flag = 1;
    }

    if (flag === 1 && i !== 0 && j === 2) {
      finalval = ',' + finalval;
      j = 0;
    }
  }
  return isNegative ? '-' + finalval : finalval;
}

let currentPlutusTransactionReferenceID = 0
let allConditionsMet = true;
let discountValue, discItemsSubTotal, material, scopePercentage, subTotal, decorpotScope, taxableAmount;
let ctpAmount, total, totalPayable, customerSavings, savingPercen, materia, discountPercent;
let totalDiscPrAmnt = 0;
let priceAmount = 0;
let totalNonDiscPrAmnt = 0;

for (let key in storeTenPercentAmount) {
  if (
      (key === 'amount' && storeTenPercentAmount[key] <= 0) ||
      (key === 'leadno' && storeTenPercentAmount[key] === "") ||
      (key === 'posmachine' && storeTenPercentAmount[key] === "")
  ) {
      allConditionsMet = false;
      break; // No need to continue checking other keys if one condition is not met
  }
}


const handleDelete = (index) => {
  const filteredArray = paymentReceiptArray.filter((item,idx) => idx !== index);
  setPaymentReceiptArray(filteredArray);
  if(filteredArray.length <= 0 ){
    setAddPaymentReceiptFileUploaded(false);
    setPaymentReceiptArray([]);
    props.setSnackInfo("Please add payment receipt","warning");
  }
};

const headers = [
  { key: "categoryname", label: "Category" },
  { key: "code", label: "Product Code" },
  { key: "productname", label: "Name" },
  { key: "description", label: "Description" },
  { key: "plyType", label: "Core Material" },
  { key: "finishType", label: 'Finish' },
  { key: "area", label: 'Area/Qty(in Sq Ft)' },
  { key: "Qty", label: 'Qty' },
  { key: "length", label: 'Length' },
  { key: "width", label: 'Width' },
  { key: "unittype", label: 'Unit' },
  { key: "cost", label: 'Cost(Per Sq Feet/Qty)' },
  { key: "itemTotal", label: 'Item total' },
  { key: "scope", label: 'Scope' },
  { key: "emptyColumn1", label: '' },
  { key: "emptyColumn2", label: '' },
  { key: "quotationValue", label: 'TOTAL QUOTATION VALUE' },
  { key: "discountPercent", label: 'Discount(%)' },
  { key: "discount", label: 'Discount' },
  { key: "subTotal", label: 'Sub total' },
  { key: "gst", label: 'GST' },
  { key: "miscellaneous", label: 'Miscellaneous amount' },
  { key: "total", label: 'TOTAL' },
  { key: "customerTotalOutflow", label: 'TOTAL CUSTOMER OUTFLOW' },
];

const getAllQuotationsForProject = async (leadId) => {
  props.setLoading(true)
  try {
    const response = await HttpService.getAllQuotationsForProject(leadId)
    setQuotationList(response.data)
    setErpProjectNo(response.data[0]?.leadId?.erpProjectNo)   //when no any quotation is available then leadId is undefine so we are handling using ? mark
    getProjectDetails(leadId)
  } catch (error) {
    console.error(error)
    props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
  }
  props.setLoading(false)
}

const getProjectDetails = async (leadId) => {
  props.setLoading(true)
  try {
    const response = await HttpService.getProjectLeadDetails(leadId)
    setProjectDetails(response.data[0])
    getFinishMaster();
    if (response.data[0].departmentId._id === constantDepartmentId.factory || response.data[0].departmentId._id === constantDepartmentId.imos || response.data[0].departmentId._id === constantDepartmentId.operation || response.data[0].departmentId._id === constantDepartmentId.chm) {
      setLeadInOutOfDesignStage(true);
    }
  } catch (error) {
    console.error(error)
    props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
  }
  props.setLoading(false)

}

const getFinishMaster = async () => {
  props.setLoading(true)
  try {
    const response = await HttpService.getFinish()
    for (let i = 0; i < response.data.length; i++) {
      if (response.data[i]['name'] === "Laminate") {
        
        setLaminateObj({
          pricePerUnit: response.data[i]['pricePerUnit'],
          _id: response.data[i]['_id'],
          name: "Laminate"
        })
        break;
      }
    }
  } catch (error) {
    console.error(error)
    props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
  }
  props.setLoading(false)
}

const onImageChange = async (e) => {
  props.setLoading(true);
  const fd = new FormData();
  fd.append('file', e.target.files[0]);
  fd.append('customerName', projectDetails.lead_no)    
  try {
    const fileUploadRes = await HttpService.uploadFile(fd);
    setOtherPaymentMethod({
      ...otherPaymentMethod,
      attachment: fileUploadRes.data, // Store the file information in the state
    });
    setIsFileUploaded(true)
  } catch (err) {
    props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error");
  }
  
  props.setLoading(false);
};

const generateQuotationExcel = async (quotationId) => {
  props.setLoading(true)
  try {
    const response = await HttpService.generateQuotationExcel(quotationId)

    
    let results = response?.data?.components;
    var data = [];

    for (let i = 0; i < results.length; i++) {
      for (let j = 0; j < results[i]['products'].length; j++) {
        let obj = {};
        obj['categoryname'] = results[i]['categoryId']?.['name'];
        obj['code'] = results[i]['products'][j]['product']?.['code'];
        obj['productname'] = results[i]['products'][j]['product']?.['name'];
        obj['description'] = results[i]['products'][j]['product']?.['description'];
        if (results[i]['products'][j]['subUnitType'] === 'Area') {
          obj['plyType'] = results[i]['plyType']?.['name'];
          obj['finishType'] = results[i]['products'][j]['finishType']?.['name'];
          obj['Qty'] = String(1);
        } else {
          obj['plyType'] = 'NA';
          obj['finishType'] = 'NA'
          obj['Qty'] = results[i]['products'][j]['area']
        }
  

        if (results[i]['products'][j]['subUnitType'] === 'Qty') {
          obj['area'] = String(0);
        } else {
          if (results[i]['products'][j]['productCustomArea'] !== 0) {
            obj['area'] = results[i]['products'][j]['productCustomArea']
          } else {
            obj['area'] = results[i]['products'][j]['area']
          }
        }

        obj['length'] = results[i]['products'][j]['length'];
        obj['width'] = results[i]['products'][j]['width'];
        obj['unittype'] = results[i]['products'][j]['unitType'] !== null ? results[i]['products'][j]['unitType']?.['name'] : 'null';
        obj['cost'] = results[i]['products'][j]['productCustomPrice'] === 0 ? results[i]['products'][j]['totalPricePerUnit'] : results[i]['products'][j]['productCustomPrice'];
        obj['itemTotal'] = results[i]['products'][j]['productPrice'];
        // When scope is enable that time remove the comment from next line
        obj['scope'] = results[i]['products'][j]['product']['scopeId']['name'];

        if (i === 0 && j === 0) {
          if (projectDetails.discountOnAllScopes === true) {
            obj['quotationValue'] = response?.data?.['totalAmount'];
            obj['discountPercent'] = response?.data?.['discountPercent'];
            obj['discount'] = response?.data?.['discountAmount'] ? response?.data?.['discountAmount'] : 0;
            obj['subTotal'] = response?.data?.['tempSt'] ? response?.data?.['tempSt'] : 0;
            //obj['customerToProc'] = response?.data?.['customerToBeProcured'] ? response?.data?.['customerToBeProcured'] : 0;
            //obj['customerToProcPercent'] = response?.data?.['materialProcured'] ? response?.data?.['materialProcured'] : 0;
            //obj['decorpotScope'] = response?.data?.['decorpotScope'] ? response?.data?.['decorpotScope'] : 0;
            obj['gst'] = response?.data?.['gstValue'] ? response?.data?.['gstValue'] : 0;
            obj['miscellaneous'] = response?.data?.['miscTotal'] ? response?.data?.['miscTotal'] : 0;
            obj['total'] = response?.data?.['mainTotal'] ? response?.data?.['mainTotal'] : 0;
            obj['customerTotalOutflow'] = response?.data?.['totalCustomerOutflow'] ? response?.data?.['totalCustomerOutflow'] : 0;
          } else {
            obj['discountPercent'] = response?.data?.['discountPercent'];
            obj['discount'] = response?.data?.['discountAmount'] ? response?.data?.['discountAmount'] : 0;
            if (response?.data?.['discItemsSubTotal' && response?.data?.['totalNonDiscPrAmnt']]) {
              obj['quotationValue'] = response?.data?.['totalDiscPrAmnt'] + response?.data?.['totalNonDiscPrAmnt'];
              obj['subTotal'] = response?.data?.['discItemsSubTotal'] ? response?.data?.['discItemsSubTotal'] + response?.data?.['totalNonDiscPrAmnt'] : 0 + response?.data?.['totalNonDiscPrAmnt'];
            } else {
              obj['quotationValue'] = response?.data?.['totalAmount'];
              obj['subTotal'] = response?.data?.['tempSt'] ? response?.data?.['tempSt'] : 0;
            }

            obj['gst'] = response?.data?.['gstValue'] ? response?.data?.['gstValue'] : 0;
            obj['miscellaneous'] = response?.data?.['miscTotal'] ? response?.data?.['miscTotal'] : 0;
            obj['total'] = response?.data?.['mainTotal'] ? response?.data?.['mainTotal'] : 0;
            obj['customerTotalOutflow'] = response?.data?.['totalCustomerOutflow'] ? response?.data?.['totalCustomerOutflow'] : 0;
          }

        }
        data.push(obj);
      }
    }

    if (response.data.hasOwnProperty('miscellaneousComponent')) {
      response.data['miscellaneousComponent']['products'].forEach((misc) => {
        let obj = {}
        obj['categoryname'] = response.data['miscellaneousComponent']['projectComponent']['name'];
        obj['code'] = misc['product']['code'];
        obj['productname'] = misc['product']['name'];
        obj['description'] = misc['product']['description'];
        if (misc['subUnitType'] === 'Area') {
          obj['plyType'] = response.data['miscellaneousComponent']['name'];
          obj['finishType'] = misc['finishType']['name'];
          obj['Qty'] = String(1);
        } else {
          obj['plyType'] = 'NA';
          obj['finishType'] = 'NA'
          obj['Qty'] = misc['area']
        }
        if (misc['subUnitType'] === 'Qty') {
          obj['area'] = String(0);
        } else {
          if (misc['productCustomArea'] !== 0) {
            obj['area'] = misc['productCustomArea']
          } else {
            obj['area'] = misc['area']
          }
        }


        obj['length'] = misc['length'];
        obj['width'] = misc['width'];
        obj['unittype'] = misc['unitType']['name'];
        obj['cost'] = misc['productPricePerUnit'];
        obj['itemTotal'] = misc['productPrice'];
        obj['scope'] = misc['product']['scopeId']['name'];
        data.push(obj);
      })
    }

    return data;
  } catch (error) {
    console.error(error)
    props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
  }
  props.setLoading(false)
}

const generateQtExcel = async (qtId) => {
  const exdata = await generateQuotationExcel(qtId);
  setCsvData(exdata)
  try {
    setTimeout(() => {
      buttonRef.current.link.click();
    });
  } catch (err) {
    console.error(err.message);
  }
  props.setLoading(false)
}

const getPostDesignSignOffObj1 = async ()=>{
  props.setLoading(true)
  try{
    const responseObj = await HttpService.getPostDesignSignOffObj();
    const postDesignCategoryObj = responseObj.data;
    return postDesignCategoryObj;
  }
  catch (err){
    console.error(err);
  }
  props.setLoading(false)
}

const openCreateQuotationModal = async (e,changeReq) => {
  let newCategoryObj;
  let servicesObj;
  if(changeReq === 'Raise Change Request')
  {
    await changeEditQuotation(projectDetails);
      newCategoryObj = await getPostDesignSignOffObj1()
  }
  else {
    servicesObj = { "products": [], "deleted": false, "_id": "62aaf790d2813657af6e2843", "name": "SERVICES", "priority": 1, "description": "SERVICES", "updatedAt": "2022-06-16T09:45:22.987Z", "createdAt": "2022-06-16T09:27:44.701Z", "__v": 0 }
  }
  getAllRooms()
  getProjectComponent()
  getAllProductsFromRateCard()
  getDiscountMaster();
  setShowCreateQuotationModal(true)
  let unitData = [];
  unitData.push({
    name: 'Sqft',
    _id: constantUnitTypeMaster.Sqft
  },
    {
      name: 'mm',
      _id: constantUnitTypeMaster.mm
    });
  setUnitList(unitData)
  handleCategorySelect(servicesObj)
  if(changeReq === 'Raise Change Request' || changeReq === 'Go To Finalize'){
    handleCategorySelect(newCategoryObj)
  }

  if (projectDetails && projectDetails?.delayToReferralBonusCategory) {
    const {
      delayPenalityCheck,
      damagesCheck,
      goodWillDiscountCheck,
      otherCheck,
      referralBonusCheck,
      delayPenality,
      damages,
      goodWillDiscount,
      other,
      referralBonus
    } = projectDetails.delayToReferralBonusCategory;

    setDamageDelayOtherValue({
      delayPenalityCheck: delayPenalityCheck || false,
      damagesCheck: damagesCheck || false,
      goodWillDiscountCheck: goodWillDiscountCheck || false,
      otherCheck: otherCheck || false,
      referralBonusCheck: referralBonusCheck || false,
      delayPenality: delayPenality || 0,
      damages: damages || 0,
      goodWillDiscount: goodWillDiscount || 0,
      other: other || 0,
      referralBonus: referralBonus || 0
    });
  }
}

const getAllRooms = async () => {
  props.setLoading(true)
  try {
    const result = await HttpService.getAllRooms()
    setCategoryList(result.data)
  } catch (error) {
    console.error(error)
    props.setSnackInfo('Error fetching Category', "error")
  }
  props.setLoading(false)
}

const getProjectComponent = async (categoryName) => {
  props.setLoading(true)
  try {
    const response = await HttpService.getProjectComponent(leadId)
    if (categoryName?.name === 'SERVICES' || categoryName?.name === 'Services') {
      createServiceProjectComp(response.data)
      setProjectComponents(response.data)
    } else {
      let sortedData = response.data.sort((a, b) => a.priority - b.priority)
      setProjectComponents(sortedData)
    }
  } catch (error) {
    console.error(error)
    props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", 'error')
  }
  props.setLoading(false)
}

const getAllProductsFromRateCard = async () => {
  props.setLoading(true)
  try {
    const response = await HttpService.getAllProductsFromRateCard(leadId)
    setProductsList(response.data.filter(product => product?.docType === "ProductMaster" && product.itemId !== undefined && product.itemId != null))
    setFinishesList(response.data.filter(product => product?.docType === "FinishTypeMaster").map(finish => {
      return {
        name: finish.itemId.name,
        pricePerUnit: finish.rate,
        _id: finish.itemId._id
      }
    }))
    setPlyList(
      response.data
        .filter(product => product?.docType === "PlyTypeMaster" && product?.itemId?.isActive === true)
        .map(ply => {
          return {
            name: ply.itemId.name,
            pricePerUnit: ply.rate,
            _id: ply.itemId._id
          };
        })
    );
  } catch (error) {
    console.error(error)
    props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
  }
  props.setLoading(false)
}

const getDiscountMaster = async () => {
  const discountResponse = await HttpService.getDiscountMasterData();
  if (discountResponse.data) {
    setDiscountMaster(discountResponse?.data?.data[0]?.value);
    setDiscountMasterMax(discountResponse?.data?.data[0]?.maxDiscountPercent);
    setDiscountMasterMaxApr26(discountResponse?.data?.data[0]?.maxDiscountPercentEffectiveApr2026);
  }
}

const getRefreshedProjectComponent = async () => {
  props.setLoading(true)
  try {
    const response = await HttpService.getProjectComponent(leadId)
    let sortedData = response.data.sort((a, b) => a.priority - b.priority)
    setProjectComponents(sortedData)
  } catch (error) {
    console.error(error)
    props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", 'error')
  }
  props.setLoading(false)
}

const handleCategorySelect = async (v) => {
  let prior;
  if (!projectComponents || projectComponents.length === 0) {
    prior = 1;
  } else {
    prior = projectComponents.length + 1;
  }
  props.setLoading(true)
  try {
    setSelectedCatergory(v)
    if (v?._id) {
      await HttpService.addProjectComponent({ projectComponent: v?._id, leadId: leadId, products: [], priority: prior })
      getProjectComponent(v)
    }
  } catch (error) {
    console.log(error, "Component Exist Message");
  }
  props.setLoading(false)
}

const getDefaultServiceMaterials = async (data, productData, prodCategory) => {
  props.setLoading(true)
  try {
    const response = await HttpService.getServicesComponent();
    response.data.product.forEach(async (ele, i) => {
      let res1 = ele;
      res1.length = 0;
      res1.width = 0;
      res1.area = 1;
      res1.isDelete = false;
      res1.isServiceItem = true;
      handleServiceProductSelect(res1, data, productData, prodCategory);
    })
    // saveQuotationChanges();
  } catch (error) {
    console.error(error)
  }
  props.setLoading(false)
}

const createServiceProjectComp = (compData) => {
  setValue(compData.length - 1);
  let defaultPly = {
    createdAt: "2018-10-26T12:00:03.638Z",
    defaultPly: true,
    defaultPlyFor: [],
    deleted: false,
    description: "Plywood",
    isActive: true,
    name: "Plywood",
    pricePerUnit: 0,
    updatedAt: "2020-11-11T10:08:50.018Z",
    __v: 0,
    _id: constantPlyTypeMaster.plywood,
  }
  setDefaultPlyType(defaultPly)

  let defaultUnitType = {}
  if (userDetails.departmentId === constantDepartmentId.sales) {
    defaultUnitType['name'] = 'Sqft';
    defaultUnitType['_id'] = constantUnitTypeMaster.Sqft;
  } else {
    defaultUnitType['name'] = 'mm';
    defaultUnitType['_id'] = constantUnitTypeMaster.mm;
  }
  setDefaultUnitType(defaultUnitType)
  let category = compData.filter((comp, idx) => comp.categoryId?.name === "SERVICES")[0]?.categoryId?.name
  setChosenCategory(category)
  let categoryId = compData.filter((comp, idx) => comp.categoryId?.name === "SERVICES")[0]?._id
  setChosenCategoryId(categoryId)
  let projectProducts = { ...projectComponentProducts }
  if (!projectProducts[category]) {
    projectProducts[category] = {}
    projectProducts[category].plyType = {}
    projectProducts[category].plyType = compData[compData.length - 1].plyType ? compData[compData.length - 1].plyType : defaultPly

    projectProducts[category].unitSelect = {}
    projectProducts[category].unitSelect = compData[compData.length - 1].unitSelect ? compData[compData.length - 1].unitSelect : defaultUnitType

    projectProducts[category]['item'] = []
    projectProducts[category]['item'] = compData[compData.length - 1].products
    setProjectComponentProducts(projectProducts)
    let finish = [{ ...selectedFinish }]
    compData[compData.length - 1].products.map((product, i) => {
      finish[i] = product.finishType
      return null
    })
    setSelectedFinish(finish)
    setServiceItemFlag(true)
    getDefaultServiceMaterials(compData, projectProducts, category)
  }
}

const handleChange = (e, v) => {
  setValue(v);
  let defaultPly = {
    createdAt: "2018-10-26T12:00:03.638Z",
    defaultPly: true,
    defaultPlyFor: [],
    deleted: false,
    description: "Plywood",
    isActive: true,
    name: "Plywood",
    pricePerUnit: 0,
    updatedAt: "2020-11-11T10:08:50.018Z",
    __v: 0,
    _id: constantPlyTypeMaster.plywood,
  }
  setDefaultPlyType(defaultPly)
  let defaultUnitType = {}
  if (userDetails.departmentId === constantDepartmentId.sales) {
    defaultUnitType['name'] = 'Sqft';
    defaultUnitType['_id'] = constantUnitTypeMaster.Sqft;
  } else {
    defaultUnitType['name'] = 'mm';
    defaultUnitType['_id'] = constantUnitTypeMaster.mm;
  }
  setDefaultUnitType(defaultUnitType)
  let category = projectComponents.filter((comp, idx) => idx === v)[0]?.categoryId?.name
  setChosenCategory(category)
  let categoryId = projectComponents.filter((comp, idx) => idx === v)[0]?._id
  setChosenCategoryId(categoryId)
  let projectProducts = { ...projectComponentProducts }
  if (!projectProducts[category]) {
    projectProducts[category] = {}
    projectProducts[category].plyType = {}
    projectProducts[category].plyType = projectComponents[v].plyType ? projectComponents[v].plyType : defaultPly

    projectProducts[category].unitSelect = {}
    projectProducts[category].unitSelect = projectComponents[v].unitSelect ? projectComponents[v].unitSelect : defaultUnitType

    projectProducts[category]['item'] = []
    projectProducts[category]['item'] = projectComponents[v].products
    let finish = [{ ...selectedFinish }]
    projectComponents[v].products.map((product, i) => {
      finish[i] = product.finishType
      return null
    })
    setSelectedFinish(finish)
    setProjectComponentProducts(projectProducts)
  }
};

const handleServiceProductSelect = (v, dataCategory, productCategoryData, leadCategory) => {
  if (v?._id) {
    let projectProducts = { ...productCategoryData }
    if (projectProducts[leadCategory]['item'].length === 0)
      projectProducts[leadCategory]['item'] = []

    let obj = {
      isDelete: v?.isDelete === undefined ? true : false,
      priority: v?.priority,
      finishType: {
        _id: laminateObj._id,
        name: laminateObj.name,
        pricePerUnit: laminateObj.pricePerUnit
      },
      product: {
        isActive: true,
        name: v?.name,
        finishInclude: v?.finishInclude,
        _id: v?._id,
        plyInclude: v?.plyInclude,
        pricePerUnit: v?.pricePerUnit,
        scope: v?.scopeId?._id,
        projectRCMasterId: v?.projectRCMasterId,
        unitType: v?.unitId?._id,
        subUnitType: v?.subUnitType,
        priority: v?.itemId?.priority
      },
      productPricePerUnit: v?.pricePerUnit,
      totalPricePerUnit: v?.pricePerUnit,
      subUnitType: v?.subUnitType,
      productCustomPrice: 0,
      productCustomArea: 0,
      customPrice: false,
      unitType: constantUnitTypeMaster.mm,
      width: v.width,
      length: v.length,
      area: v.area,
      changeArea: 0
    }
    
    if (obj['subUnitType'] === 'Area') {
      if (obj['product']['finishInclude']) {
        obj['totalPricePerUnit'] += obj['finishType']['pricePerUnit'];
      }
      if (obj['product']['plyInclude']) {
        obj['totalPricePerUnit'] += projectProducts[leadCategory]?.['plyType']?.['pricePerUnit'];
      }
    }
    obj['productPrice'] = obj['area'] * obj['totalPricePerUnit'];
    obj['changePrice'] = obj['productPrice'];
    obj['changeArea'] = obj['area'];
    // ends here
    if (obj['product']['name'] === 'Stone Cladding') {
      obj['fixingPrice'] = v?.fixingPrice;
      obj['productPrice'] = obj['totalPricePerUnit'] + (obj['fixingPrice'] * 100);
    }
    projectProducts[leadCategory]['item'].push(obj)
    setProjectComponentProducts(projectProducts)
  }
}

const handleDoubleClick = async (idx) => {
  if (idx > 0) {
    let obj = [
      {
        component_id: projectComponents[idx]['_id'],
        priority: projectComponents[idx - 1]['priority']
      },
      {
        component_id: projectComponents[idx - 1]['_id'],
        priority: projectComponents[idx]['priority']
      },
    ]
    props.setLoading(true)
    const updateCategoryPosition = await HttpService.editCategoryPositionPriority(obj);
    if (updateCategoryPosition.status === 200) {
      props.setSnackInfo('Category position updated', "success")
      getRefreshedProjectComponent()
    } else {
      props.setSnackInfo('Something went wrong', "error")
    }
    props.setLoading(false)
  }
}

const handleProductSelect = (v) => {
  // console.log('v',v)
  if (v?._id) {
    let projectProducts = { ...projectComponentProducts }
    if (projectProducts[chosenCategory]['item'].length === 0)
      projectProducts[chosenCategory]['item'] = []

    let calculatedWidth = 300, calculatedArea = 1, fixingCharge = 0, depth = 300, removeCustomAreaCheck = false
    
    if(falseCeilingValidate(v?.itemId?.name))
    {
      calculatedWidth = 300
      calculatedArea = 18
      if(v?.itemId?.unitId == rftUnitTypeId || v?.itemId?.name.toLowerCase().includes('rafter'))
      {
        if(projectComponentProducts?.[chosenCategory]?.unitSelect?.name == "mm")
        {
          calculatedArea = Number(((300 * 3) / 300).toFixed(2))
        }
        else
        {
          calculatedArea = 300 * 3
        }

      }
      else if(v?.itemId?.name.includes('False ceiling (Peripheral with Cove'))
      {
        
        removeCustomAreaCheck = true
        if(projectComponentProducts?.[chosenCategory]?.unitSelect?.name == "mm")
        {
          calculatedArea = Number(((((calculatedWidth + 300) * (depth + 900)) * 2) / 90000).toFixed(2))
        }
        else
        {
          calculatedArea = ((calculatedWidth + 300) * (depth + 3)) * 2
        }
      }
      else if(v?.itemId?.name.includes('False ceiling (Peripheral, No Cove'))
      {
        
        removeCustomAreaCheck = true
        if(projectComponentProducts?.[chosenCategory]?.unitSelect?.name == "mm")
        {
          calculatedArea = Number(((((calculatedWidth + 300) * (depth + 300)) * 2) / 90000).toFixed(2))
        }
        else
        {
          calculatedArea = ((calculatedWidth + 300) * (depth + 1)) * 2
        }
      }
      else if(v?.itemId?.name.includes('False ceiling (Island with Cove'))
      {
  
        if(projectComponentProducts?.[chosenCategory]?.unitSelect?.name == "mm")
        {
          
          calculatedArea = Number((((calculatedWidth * 300) + ((calculatedWidth + 300) * 1800)) / 90000).toFixed(2))
        }
        else
        {
          
          calculatedArea = (calculatedWidth * 300) + ((calculatedWidth + 300) * 6)
        }
      }
      else if(v?.itemId?.name.includes('False ceiling (Island, No Cove'))
      {
        
        if(projectComponentProducts?.[chosenCategory]?.unitSelect?.name == "mm")
        {
          calculatedArea = Number((((calculatedWidth * 300) + ((calculatedWidth + 300) * 600)) / 90000).toFixed(2))
        }
        else
        {
          calculatedArea = (calculatedWidth * 300) + ((calculatedWidth + 300) * 2)
        }
      }
      else if (v?.itemId?.name.includes("False ceiling in Plywood")) {
        if (projectComponentProducts?.[chosenCategory]?.unitSelect?.name == "mm") {
          calculatedArea = 1 ;
        }
        else {
          calculatedArea = Number(calculatedWidth * 300).toFixed(2);
          // calculatedArea = Number(((300 * 3))).toFixed(2)
        }
      }
    }
    else if(v?.itemId?.name == "Granite - Material + Fixing (Min order quantity 20 sft)")
    {
      if(projectComponentProducts?.[chosenCategory]?.unitSelect?.name == "mm")
      {
        calculatedWidth = 750
        calculatedArea = 2.5
      }
      else
      {
        calculatedWidth = 2.5
        calculatedArea = 750
      }
    }
    else if(v?.itemId?.name == "Granite for Island Counter - Material  + Fixing (Min order quantity 20 sft)")
    {
      if(projectComponentProducts?.[chosenCategory]?.unitSelect.name == "mm")
      {
        calculatedArea = Number((((300 + 300) * (300 + 300)) / 90000).toFixed(2))
      }
      else
      {
        calculatedArea = Number((300 + 1) * (300 + 1))
      }
    }
    else if(v?.itemId?.name.includes("TIles fixing charges for tiles"))
    {
      calculatedArea = 0
    }
    else if(v?.itemId?.subUnitType === 'Area')
    {
      calculatedWidth = 300
      calculatedArea = 1
    }
    
    let obj = {
      prevQtData : true,
      newItemAdded: true,
      isDelete: v?.itemId?.isDelete === undefined ? true : false,
      priority: v?.itemId?.priority,
      finishType: {
        _id: laminateObj._id,
        name: laminateObj.name,
        pricePerUnit: laminateObj.pricePerUnit
      },
      product: {
        isActive: true,
        name: v?.itemId?.name,
        finishInclude: v?.itemId?.finishInclude,
        _id: v?.itemId?._id,
        plyInclude: v?.itemId?.plyInclude,
        scope: v?.itemId?.scopeId,
        projectRCMasterId: v?.projectRCMasterId,
        unitType: v?.itemId?.unitId,
        subUnitType: v?.itemId?.subUnitType,
        priority: v?.itemId?.priority
      },
      productPricePerUnit: v?.rate,
      totalPricePerUnit: v?.rate,
      subUnitType: v?.itemId?.subUnitType,
      productCustomPrice: 0,
      productCustomArea: 0,
      customPrice: false,
      unitType: constantUnitTypeMaster.mm, // mm unit id
      moqInSqft: v?.itemId?.moqInSqft,
      fixingCharge: fixingCharge,
      depth: depth,
      width: calculatedWidth,
      length: falseCeilingValidate(v?.itemId?.name) || v?.itemId?.name == "Granite - Material + Fixing (Min order quantity 20 sft)" ? 300 : v?.itemId?.subUnitType === 'Area' ? 300 : 0,
      area: calculatedArea,
      changeArea: removeCustomAreaCheck ? false : falseCeilingValidate(v?.itemId?.name) ? 18 : v?.itemId?.subUnitType === 'Area' && 0,
    }
    
    if (falseCeilingValidate(obj['product'].name)) {
      obj['customArea'] = false;
    }

    if (projectProducts[chosenCategory]?.unitSelect?.name === 'Sqft' && obj['subUnitType'] === 'Area') {
      obj['unitType'] = constantUnitTypeMaster.Sqft; // SqFt unit id
      if (falseCeilingValidate(obj['product'].name)) {
        if(!v?.itemId?.name.includes('False ceiling (Peripheral with Cove') && !v?.itemId?.name.includes('False ceiling (Peripheral, No Cove') && !v?.itemId?.name.includes('False ceiling (Island with Cove') && !v?.itemId?.name.includes('False ceiling (Island, No Cove') && !v?.itemId?.name.includes('False ceiling in Plywood') && !(v?.itemId?.unitId == rftUnitTypeId))
        {
          obj['area'] = 5400;
        }
      }
      else if(v?.itemId?.name == "Granite - Material + Fixing (Min order quantity 20 sft)")
      {
        if(projectComponentProducts?.[chosenCategory]?.unitSelect?.name == "mm")
        {
          obj['width'] = 750
          obj['length'] = 300
          obj['area'] = 2.5
        }
        else
        {
          obj['width'] = 2.5
          obj['length'] = 300
          obj['area'] = 750
        }
      }
      else if(v?.itemId?.name == "Granite for Island Counter - Material  + Fixing (Min order quantity 20 sft)")
      {
        if(projectComponentProducts?.[chosenCategory]?.unitSelect.name == "mm")
        {
          obj['area'] = Number((((300 + 300) * (300 + 300)) / 90000).toFixed(2))
        }
        else
        {
          obj['area'] = Number((300 + 1) * (300 + 1))
        }
      }
      else if(v?.itemId?.name.includes("TIles fixing charges for tiles"))
      {
      }
      else
      {
        obj['area'] = 90000;
      }
    }
    // Add ply price and finish price if the product is eligible for those
    if (obj['subUnitType'] === 'Area') {
      if (obj['product']['finishInclude']) {  
        obj['totalPricePerUnit'] += obj['finishType']['pricePerUnit'];
      }
      if (obj['product']['plyInclude']) {
        obj['totalPricePerUnit'] += projectProducts[chosenCategory]?.['plyType']?.['pricePerUnit'];
      }
    }
    obj['productPrice'] = obj['area'] * obj['totalPricePerUnit'];
    obj['changePrice'] = obj['productPrice'];
    obj['changeArea'] = obj['area'];
    // ends here
    if (obj['product']['name'] === 'Stone Cladding') {
      obj['fixingPrice'] = v?.fixingPrice;
      obj['productPrice'] = obj['totalPricePerUnit'] + (obj['fixingPrice'] * 100);
    }
    setSelectedFinish(obj.finishType)
    projectProducts[chosenCategory]['item'].push(obj)
    projectProducts[chosenCategory]['item'].sort((a, b) => a['priority'] - b['priority']);
    setProjectComponentProducts(projectProducts)
  }
}

const handleProductSelect1 = async(v)=> {
  let projectProducts = { ...projectComponentProducts }
  v.forEach((vItem) => {
    // Create a new object for each item in the array 'v'
    let obj = {
      categoryQtData: true,
      isDelete: false,
      priority: 1,
      finishType: {
        _id: laminateObj._id,
        name: "Laminate",
        pricePerUnit: 0
      },
      product: {
        isActive: true,
        name: vItem?.itemId?.name,
        finishInclude: vItem?.itemId?.finishInclude,
        _id: vItem?.itemId?._id,
        plyInclude: vItem?.itemId?.plyInclude,
        scope: vItem?.itemId?.scopeId,
        projectRCMasterId: vItem?.projectRCMasterId,
        unitType: vItem?.itemId?.unitId,
        subUnitType: vItem?.itemId?.subUnitType,
        priority: vItem?.itemId?.priority
      },
      productPricePerUnit: 0,
      productPrice: vItem?.rate,
      changePrice: vItem?.rate,
      totalPricePerUnit: vItem?.rate,
      subUnitType: vItem?.itemId?.subUnitType,
      productCustomPrice: 0,
      productCustomArea: 0,
      customPrice: false,
      unitType: constantUnitTypeMaster.mm, // mm unit id
      moqInSqft: vItem?.itemId?.moqInSqft,
      fixingCharge: 0,
      depth: 0,
      width: 0,
      length: 0,
      area: 0,
      changeArea: 0
    };
    // Push the new object into the 'item' array of the chosen category
    setSelectedFinish(obj.finishType)
    projectProducts[chosenCategory]['item'].push(obj);
  });
  projectProducts[chosenCategory]['item'].sort((a, b) => a['priority'] - b['priority']);
  setProjectComponentProducts(projectProducts)
}

const handlePlySelect = (v) => {
  let projectProducts = { ...projectComponentProducts }
  projectProducts[chosenCategory]['plyType'] = v === null ? defaultPlyType : v;
  projectProducts[chosenCategory]['item'].forEach(element => {
    if (!element['product']?.['plyInclude']) {
      return;
    }
    if (element['subUnitType'] === 'Area') {
      let plyPrice = v === null ? defaultPlyType.pricePerUnit : v?.pricePerUnit;
      element['totalPricePerUnit'] = element['productPricePerUnit'] + element['finishType']?.['pricePerUnit'] + plyPrice
      element['productPrice'] = element['totalPricePerUnit'] * element['area'];
      element['changePrice'] = element['productPrice'];
    }
  });
  setProjectComponentProducts(projectProducts)
}

const handleFinishSelect = (v, i) => {
  let projectProducts = { ...projectComponentProducts }
  let itemObj = projectProducts[chosenCategory]['item'][i];
  finshesList.forEach((ele, i) => {
    if (v?.name === ele.name) {
      setSelectedFinish({
        pricePerUnit: ele['pricePerUnit'],
        _id: ele['_id'],
        name: ele['name']
      })
      itemObj['finishType']['name'] = ele['name'];
      itemObj['finishType']['pricePerUnit'] = ele['pricePerUnit'];
      itemObj['finishType']['_id'] = ele['_id'];
      itemObj['totalPricePerUnit'] = itemObj['productPricePerUnit'] + itemObj['finishType']['pricePerUnit'];
      if (itemObj['product']?.['plyInclude'] && itemObj['subUnitType'] === 'Area') {
        itemObj['totalPricePerUnit'] = itemObj['totalPricePerUnit'] + projectProducts[chosenCategory]['plyType']['pricePerUnit']
      }
      itemObj['productPrice'] = itemObj['totalPricePerUnit'] * itemObj['area'];
      itemObj['changePrice'] = itemObj['productPrice'];
    }
  })

  setProjectComponentProducts(projectProducts)
}

const removeItemFromList = (i) => {
  let projectProducts = { ...projectComponentProducts }
  let chosenCategoryProducts = JSON.parse(JSON.stringify(projectProducts[chosenCategory]))
  delete projectProducts[chosenCategory]
  setProjectComponentProducts({
    ...projectComponentProducts,
    [chosenCategory]: {
      item: chosenCategoryProducts.item?.filter((item, idx) => i !== idx),
      plyType: projectComponentProducts[chosenCategory].plyType,
      unitSelect: projectComponentProducts[chosenCategory].unitSelect
    }
  })
}

const handleAreaQtyCheck = (e, i, optionSelected) =>
{
  let projectProducts = { ...projectComponentProducts }
  let value = Number(e.target.value)

  if(projectComponentProducts?.[chosenCategory]?.unitSelect?.name == 'mm')
  {
      let newEvent = {...e}
      newEvent.target.value = value;
      handleAreaQtyChange(newEvent, i, optionSelected)
  }
  else if(projectComponentProducts?.[chosenCategory]?.unitSelect?.name == 'Sqft')
  {
      let newEvent = {...e}
      newEvent.target.value = value
      handleAreaQtyChange(newEvent, i, optionSelected)
  }
}
const handleAreaQtyChange = (e, i, optionSelected) => {
  let projectProducts = { ...projectComponentProducts }
  projectProducts[chosenCategory]['item'][i][e.target.name] = e.target.value
  switch (optionSelected) {
    case 'l':
      
      if (falseCeilingValidate(projectProducts[chosenCategory]['item'][i]['product']['name']))
      {
        if(projectProducts[chosenCategory]['item'][i]['product']['unitType'] == rftUnitTypeId || projectProducts[chosenCategory]['item'][i]['product']['name'].toLowerCase().includes('rafter'))
        {
          if (projectProducts[chosenCategory].unitSelect.name === 'mm')
            {
              projectProducts[chosenCategory]['item'][i]['area'] = Number(((Number(projectProducts[chosenCategory]['item'][i]['length']) * 3) / 300).toFixed(2))
            }
            else
            {
              projectProducts[chosenCategory]['item'][i]['area'] = (Number(projectProducts[chosenCategory]['item'][i]['length']) * 3)
            }
            projectProducts[chosenCategory]['item'][i]['productPrice'] = projectProducts[chosenCategory]['item'][i]['totalPricePerUnit'] * projectProducts[chosenCategory]['item'][i]['area'];
            projectProducts[chosenCategory]['item'][i]['changePrice'] = projectProducts[chosenCategory]['item'][i]['productPrice'];
            projectProducts[chosenCategory]['item'][i]['changeArea'] = projectProducts[chosenCategory]['item'][i]['area'];
        }
        else if(projectProducts[chosenCategory]['item'][i]['product']['name'].includes('False ceiling (Peripheral with Cove'))
        {
          projectProducts[chosenCategory]['item'][i]['depth'] = Number(projectProducts[chosenCategory]['item'][i]['depth'])
          if (projectProducts[chosenCategory].unitSelect.name === 'mm')
          {
            projectProducts[chosenCategory]['item'][i]['area'] = Number(((((Number(projectProducts[chosenCategory]['item'][i]['length']) + Number(projectProducts[chosenCategory]['item'][i]['width'])) * (Number(projectProducts[chosenCategory]['item'][i]['depth']) + 900)) * 2) / 90000).toFixed(2))
          }
          else
          {
            projectProducts[chosenCategory]['item'][i]['area'] = ((Number(projectProducts[chosenCategory]['item'][i]['length']) + Number(projectProducts[chosenCategory]['item'][i]['width'])) * (Number(projectProducts[chosenCategory]['item'][i]['depth']) + 3)) * 2
          }
          projectProducts[chosenCategory]['item'][i]['productPrice'] = projectProducts[chosenCategory]['item'][i]['totalPricePerUnit'] * projectProducts[chosenCategory]['item'][i]['area'];
          projectProducts[chosenCategory]['item'][i]['changePrice'] = projectProducts[chosenCategory]['item'][i]['productPrice'];
          projectProducts[chosenCategory]['item'][i]['changeArea'] = projectProducts[chosenCategory]['item'][i]['area'];
    
        }
        else if(projectProducts[chosenCategory]['item'][i]['product']['name'].includes('False ceiling (Peripheral, No Cove'))
        {
          projectProducts[chosenCategory]['item'][i]['depth'] = Number(projectProducts[chosenCategory]['item'][i]['depth'])
          if (projectProducts[chosenCategory].unitSelect.name === 'mm')
          {
            projectProducts[chosenCategory]['item'][i]['area'] = Number(((((Number(projectProducts[chosenCategory]['item'][i]['length']) + Number(projectProducts[chosenCategory]['item'][i]['width'])) * (Number(projectProducts[chosenCategory]['item'][i]['depth']) + 300)) * 2) / 90000).toFixed(2))
          }
          else
          {
            projectProducts[chosenCategory]['item'][i]['area'] = ((Number(projectProducts[chosenCategory]['item'][i]['length']) + Number(projectProducts[chosenCategory]['item'][i]['width'])) * (Number(projectProducts[chosenCategory]['item'][i]['depth']) + 1)) * 2
          }
          projectProducts[chosenCategory]['item'][i]['productPrice'] = projectProducts[chosenCategory]['item'][i]['totalPricePerUnit'] * projectProducts[chosenCategory]['item'][i]['area'];
          projectProducts[chosenCategory]['item'][i]['changePrice'] = projectProducts[chosenCategory]['item'][i]['productPrice'];
          projectProducts[chosenCategory]['item'][i]['changeArea'] = projectProducts[chosenCategory]['item'][i]['area'];
    
        }
        else if(projectProducts[chosenCategory]['item'][i]['product']['name'].includes('False ceiling (Island with Cove'))
        {
          if (projectProducts[chosenCategory].unitSelect.name === 'mm')
          {
            
            projectProducts[chosenCategory]['item'][i]['area'] = Number((((Number(projectProducts[chosenCategory]['item'][i]['length']) * Number(projectProducts[chosenCategory]['item'][i]['width'])) + ((Number(projectProducts[chosenCategory]['item'][i]['length']) + Number(projectProducts[chosenCategory]['item'][i]['width'])) * 1800)) / 90000).toFixed(2))
          }
          else
          {
            
            projectProducts[chosenCategory]['item'][i]['area'] = (Number(projectProducts[chosenCategory]['item'][i]['length']) * Number(projectProducts[chosenCategory]['item'][i]['width'])) + ((Number(projectProducts[chosenCategory]['item'][i]['length']) + Number(projectProducts[chosenCategory]['item'][i]['width'])) * 6)
          }
          projectProducts[chosenCategory]['item'][i]['productPrice'] = projectProducts[chosenCategory]['item'][i]['totalPricePerUnit'] * projectProducts[chosenCategory]['item'][i]['area'];
          projectProducts[chosenCategory]['item'][i]['changePrice'] = projectProducts[chosenCategory]['item'][i]['productPrice'];
          projectProducts[chosenCategory]['item'][i]['changeArea'] = projectProducts[chosenCategory]['item'][i]['area'];
    
        }
        else if(projectProducts[chosenCategory]['item'][i]['product']['name'].includes('False ceiling (Island, No Cove'))
        {
          if (projectProducts[chosenCategory].unitSelect.name === 'mm')
          {
            
            projectProducts[chosenCategory]['item'][i]['area'] = Number((((Number(projectProducts[chosenCategory]['item'][i]['length']) * Number(projectProducts[chosenCategory]['item'][i]['width'])) + ((Number(projectProducts[chosenCategory]['item'][i]['length']) + Number(projectProducts[chosenCategory]['item'][i]['width'])) * 600)) / 90000).toFixed(2))
          }
          else
          {
            projectProducts[chosenCategory]['item'][i]['area'] = (Number(projectProducts[chosenCategory]['item'][i]['length']) * Number(projectProducts[chosenCategory]['item'][i]['width'])) + ((Number(projectProducts[chosenCategory]['item'][i]['length']) + Number(projectProducts[chosenCategory]['item'][i]['width'])) * 2)
          }
          projectProducts[chosenCategory]['item'][i]['productPrice'] = projectProducts[chosenCategory]['item'][i]['totalPricePerUnit'] * projectProducts[chosenCategory]['item'][i]['area'];
          projectProducts[chosenCategory]['item'][i]['changePrice'] = projectProducts[chosenCategory]['item'][i]['productPrice'];
          projectProducts[chosenCategory]['item'][i]['changeArea'] = projectProducts[chosenCategory]['item'][i]['area'];
        }
        else if(projectProducts[chosenCategory]['item'][i]['product']['name'].includes('False ceiling in Plywood'))
        {
          projectProducts[chosenCategory]['item'][i]['area'] = (Number(projectProducts[chosenCategory]['item'][i]['width']) * Number(projectProducts[chosenCategory]['item'][i]['length']));
          if (projectProducts[chosenCategory].unitSelect.name === 'mm') {
            projectProducts[chosenCategory]['item'][i]['area'] = (Number(projectProducts[chosenCategory]['item'][i]['width']) * Number(projectProducts[chosenCategory]['item'][i]['length'])) / 300;
            projectProducts[chosenCategory]['item'][i]['area'] = projectProducts[chosenCategory]['item'][i]['area'] / 300;
            projectProducts[chosenCategory]['item'][i]['area'] = projectProducts[chosenCategory]['item'][i]['area'].toFixed(2);
          }
          projectProducts[chosenCategory]['item'][i]['changeArea'] = projectProducts[chosenCategory]['item'][i]['area'];
          projectProducts[chosenCategory]['item'][i]['productPrice'] = projectProducts[chosenCategory]['item'][i]['area'] * projectProducts[chosenCategory]['item'][i]['totalPricePerUnit'];
          projectProducts[chosenCategory]['item'][i]['productPrice'] = projectProducts[chosenCategory]['item'][i]['productPrice'].toFixed(2);
          projectProducts[chosenCategory]['item'][i]['changePrice'] = projectProducts[chosenCategory]['item'][i]['productPrice'];
        } else
        {
          projectProducts[chosenCategory]['item'][i]['area'] = (Number(projectProducts[chosenCategory]['item'][i]['width']) + Number(projectProducts[chosenCategory]['item'][i]['length'])) * 9;
          if (projectProducts[chosenCategory].unitSelect.name === 'mm') {
            projectProducts[chosenCategory]['item'][i]['area'] = projectProducts[chosenCategory]['item'][i]['area'] / 300;
            projectProducts[chosenCategory]['item'][i]['area'] = projectProducts[chosenCategory]['item'][i]['area'].toFixed(2);
          }
          projectProducts[chosenCategory]['item'][i]['changeArea'] = projectProducts[chosenCategory]['item'][i]['area'];

          projectProducts[chosenCategory]['item'][i]['productPrice'] = projectProducts[chosenCategory]['item'][i]['area'] * projectProducts[chosenCategory]['item'][i]['totalPricePerUnit'];
          projectProducts[chosenCategory]['item'][i]['productPrice'] = projectProducts[chosenCategory]['item'][i]['productPrice'].toFixed(2);
          projectProducts[chosenCategory]['item'][i]['changePrice'] = projectProducts[chosenCategory]['item'][i]['productPrice'];
        }
      }
      else if(projectProducts[chosenCategory]['item'][i]['product']['name'] === 'Granite - Material + Fixing (Min order quantity 20 sft)')
      {
        if (projectProducts[chosenCategory].unitSelect.name === 'mm')
        {
          projectProducts[chosenCategory]['item'][i]['area'] =  Number(((Number(projectProducts[chosenCategory]['item'][i]['width']) * Number(projectProducts[chosenCategory]['item'][i]['length'])) / 90000).toFixed(2))
        }
        else
        {
          projectProducts[chosenCategory]['item'][i]['area'] =  Number((Number(projectProducts[chosenCategory]['item'][i]['width']) * Number(projectProducts[chosenCategory]['item'][i]['length'])).toFixed(2))
        }
        projectProducts[chosenCategory]['item'][i]['productPrice'] = Number((Number(projectProducts[chosenCategory]['item'][i]['area']) * Number(projectProducts[chosenCategory]['item'][i]['totalPricePerUnit'])).toFixed(2));
        projectProducts[chosenCategory]['item'][i]['changePrice'] = projectProducts[chosenCategory]['item'][i]['productPrice'];
        projectProducts[chosenCategory]['item'][i]['changeArea'] = projectProducts[chosenCategory]['item'][i]['area'];
      }
      else if(projectProducts[chosenCategory]['item'][i]['product']['name'] === 'Granite for Island Counter - Material  + Fixing (Min order quantity 20 sft)')
      {
        if (projectProducts[chosenCategory].unitSelect.name === 'mm')
        {
          projectProducts[chosenCategory]['item'][i]['area'] =  Number((((Number(projectProducts[chosenCategory]['item'][i]['width']) + 300) * (Number(projectProducts[chosenCategory]['item'][i]['length']) + 300)) / 90000).toFixed(2))
        }
        else
        {
          projectProducts[chosenCategory]['item'][i]['area'] =  Number(((Number(projectProducts[chosenCategory]['item'][i]['width']) + 1) * (Number(projectProducts[chosenCategory]['item'][i]['length']) + 1)).toFixed(2))
        }
        projectProducts[chosenCategory]['item'][i]['productPrice'] = Number((Number(projectProducts[chosenCategory]['item'][i]['area']) * Number(projectProducts[chosenCategory]['item'][i]['totalPricePerUnit'])).toFixed(2));
        projectProducts[chosenCategory]['item'][i]['changePrice'] = projectProducts[chosenCategory]['item'][i]['productPrice'];
        projectProducts[chosenCategory]['item'][i]['changeArea'] = projectProducts[chosenCategory]['item'][i]['area'];
      }
      else if(projectProducts[chosenCategory]['item'][i]['product']['name'].includes('TIles fixing charges for tiles'))
      {
        projectProducts[chosenCategory]['item'][i]['fixingCharge'] = Number(projectProducts[chosenCategory]['item'][i]['fixingCharge'])
        projectProducts[chosenCategory]['item'][i]['area'] = Number((Number(projectProducts[chosenCategory]['item'][i]['fixingCharge']) * 1.2).toFixed(2))
  
        projectProducts[chosenCategory]['item'][i]['productPrice'] = Number((Number(projectProducts[chosenCategory]['item'][i]['area']) * Number(projectProducts[chosenCategory]['item'][i]['totalPricePerUnit'])).toFixed(2));
        projectProducts[chosenCategory]['item'][i]['changePrice'] = projectProducts[chosenCategory]['item'][i]['productPrice'];
        projectProducts[chosenCategory]['item'][i]['changeArea'] = projectProducts[chosenCategory]['item'][i]['area'];
      }
      else if (projectProducts[chosenCategory]['item'][i]['product']['name'] === 'Stone Cladding')
      {
        projectProducts[chosenCategory]['item'][i]['area'] = Number(projectProducts[chosenCategory]['item'][i]['width']) * Number(projectProducts[chosenCategory]['item'][i]['length']);
        if (projectProducts[chosenCategory].unitSelect.name === 'mm') {
          projectProducts[chosenCategory]['item'][i]['area'] = projectProducts[chosenCategory]['item'][i]['area'] / 90000;
          projectProducts[chosenCategory]['item'][i]['area'] = Number(projectProducts[chosenCategory]['item'][i]['area'].toFixed(2));
        }
        projectProducts[chosenCategory]['item'][i]['changeArea'] = projectProducts[chosenCategory]['item'][i]['area'];
        projectProducts[chosenCategory]['item'][i]['productPrice'] = projectProducts[chosenCategory]['item'][i]['totalPricePerUnit'] * projectProducts[chosenCategory]['item'][i]['area'];
        if (projectProducts[chosenCategory]['item'][i]['area'] > 100) {
          projectProducts[chosenCategory]['item'][i]['productPrice'] += (projectProducts[chosenCategory]['item'][i]['fixingPrice'] * projectProducts[chosenCategory]['item'][i]['area']);
        } else {
          projectProducts[chosenCategory]['item'][i]['productPrice'] += (projectProducts[chosenCategory]['item'][i]['fixingPrice'] * 100);
        }
      }
      else
      {
        projectProducts[chosenCategory]['item'][i]['area'] = Number((projectProducts[chosenCategory]['item'][i]['width']) * Number(projectProducts[chosenCategory]['item'][i]['length'])).toFixed(2);
        if (projectProducts[chosenCategory].unitSelect.name === 'mm') {
          projectProducts[chosenCategory]['item'][i]['area'] = Number(projectProducts[chosenCategory]['item'][i]['area']) / 90000;
          projectProducts[chosenCategory]['item'][i]['area'] = Number(projectProducts[chosenCategory]['item'][i]['area']).toFixed(2);
        }
        projectProducts[chosenCategory]['item'][i]['changeArea'] = projectProducts[chosenCategory]['item'][i]['area'];
        projectProducts[chosenCategory]['item'][i]['productPrice'] =
          Number((projectProducts[chosenCategory]['item'][i]['totalPricePerUnit']
          ) * Number((projectProducts[chosenCategory]['item'][i]['area'])).toFixed(2));
        projectProducts[chosenCategory]['item'][i]['productPrice'] = Number(projectProducts[chosenCategory]['item'][i]['productPrice']).toFixed(2);
        projectProducts[chosenCategory]['item'][i]['changePrice'] = projectProducts[chosenCategory]['item'][i]['productPrice'];
      }
      break;

    case 'a':
      projectProducts[chosenCategory]['item'][i]['productPrice'] = projectProducts[chosenCategory]['item'][i]['productPricePerUnit'] * projectProducts[chosenCategory]['item'][i]['area'];
      projectProducts[chosenCategory]['item'][i]['changePrice'] = projectProducts[chosenCategory]['item'][i]['productPrice'];
      projectProducts[chosenCategory]['item'][i]['changeArea'] = projectProducts[chosenCategory]['item'][i]['area'];
      break;

    case 'r':
      projectProducts[chosenCategory]['item'][i]['productPrice'] = projectProducts[chosenCategory]['item'][i]['productPricePerUnit'] * projectProducts[chosenCategory]['item'][i]['productCustomArea'];
      projectProducts[chosenCategory]['item'][i]['changePrice'] = projectProducts[chosenCategory]['item'][i]['productPrice'];
      break;

    default:
      console.log('default');
  }
  setProjectComponentProducts(projectProducts)
}

const handleChangePriority = (e, i) => {
  let projectProducts = { ...projectComponentProducts }
  projectProducts[chosenCategory]['item'][i][e.target.name] = e.target.value
  setProjectComponentProducts(projectProducts)
}

const sortPriorityData = (e) => {
  if (e.key === "Enter") {
    let projectProducts = { ...projectComponentProducts }
    projectProducts[chosenCategory]['item'].sort((a, b) => a['priority'] - b['priority']);
    setProjectComponentProducts(projectProducts)
  }
}

const sortPriorityOnOnBlur = (e) => {
  let projectProducts = { ...projectComponentProducts }
  projectProducts[chosenCategory]['item'].sort((a, b) => a['priority'] - b['priority']);
  setProjectComponentProducts(projectProducts)
};

const saveQuotationChanges = async () => {
  props.setLoading(true)
  let obj = [];
  let validateFlag = validateArea(projectComponentProducts[chosenCategory]['item']);
  if (validateFlag > 0) {
    props.setSnackInfo("Please check MOQ", 'error');
    return; 
  }
  Object.keys(projectComponentProducts).forEach(ele => {
    let tmp = projectComponentProducts[ele];
    projectComponents.forEach(e => {
      if (e.categoryId.name === ele) {
        obj.push({
          categoryId: e.categoryId._id,
          plyType: tmp.plyType,
          leadId: leadId,
          products: tmp.item
        })
      }
    })
  })
  
  let array = [];
  // Check conditions before proceeding with calculations
  if (
    projectDetails.contractCustomerApproved &&
    projectDetails.contractFinanceApproved &&
    projectDetails.designStages === 'Design Sign-off'
  ) {
    // Iterate over obj array (make sure obj is defined and accessible)
    for (let i = 0; i < obj?.length; i++) {
      for (let j = 0; j < obj[i]?.products?.length; j++) {
        if (obj[i]?.products[j]?.prevQtData) {
          if (obj[i]?.products[j]?.productPrice >= 0) {
            obj[i].products[j].negativeQtCr = false;
            obj[i].products[j].positiveQtCr = true;
          } else {
            obj[i].products[j].negativeQtCr = true;
            obj[i].products[j].positiveQtCr = false;
          }
          array.push(+obj[i].products[j]?.productPrice);
        }
      }
    }
    // Perform calculations based on conditions
    const hasNegativeValue = array.some(value => value <= 0);
    if (hasNegativeValue) {
      const sum = parseFloat(array.reduce((accumulator, currentValue) => accumulator + currentValue, 0));
      if (sum <= -20000) {
        setSendApprovalQtCrValue({ ...sendApprovalQtCrValue, valuesGreaterThan20k: true });
        setDiffQtChanges(sum)
      } else {
        setSendApprovalQtCrValue({ ...sendApprovalQtCrValue, valuesLessThan20k: true });
      }
    } else {
      const sum = array.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
      setSendApprovalQtCrValue({ ...sendApprovalQtCrValue, allPositiveValues: true });
    }
  }
  const response = await HttpService.editProjectComponentQuotation(obj);

  if (response.status === 200) {
      props.setSnackInfo('Quotation Updated', "success")
      getProjectComponent()
  } else {
    props.setSnackInfo('Something went wrong', "error")
  }
  props.setLoading(false)
}

// area calculation here allow -ve value also
const validateArea = (productArray) => {
  let validateFlag = 0;
  productArray.forEach(ele => {
    if(ele['area'] < ele['moqInSqft'])
    {
      validateFlag = ele['area'];
    }
  });
  props.setLoading(false)
  return validateFlag;
}


const previewQuotation = async () => {
  await saveQuotationChanges();
  // Close the Quotation List modal
  setShowCreateQuotationModal(false);
  // Open Preview quotation modal
  setOpenPreviewModal(true);
  // Getting the list of Preview Items
  if (projectDetails.complimentaryItemStatus === "Sent for Approval") {
    props.setSnackInfo("Please wait till the complimentary items are approved", "warning")
  }
  const response = await HttpService.getProjectComponent(leadId)
  let data = response.data.shift();
  let sortedData = response.data.sort((a, b) => a.priority - b.priority)
  sortedData.push(data)
  setProjectComponents(sortedData)

  let obj = [];
  sortedData.forEach(ele => {
    obj.push({
      product: ele.products,
      spacename: ele.categoryId.name,
    })
  })

  const newItemProductPrice = (objArray) => {
    return objArray.reduce((totalPrice, obj) => {
      if (obj.spacename === "POST DESIGN SIGN-OFF CHANGES") {
        return obj.product.reduce((subtotal, productItem) => {
          if (productItem.positiveQtCr || productItem.negativeQtCr) {
            return subtotal + productItem.productPrice;
          }
          return subtotal;
        }, totalPrice);
      }
      return totalPrice;
    }, 0);
  };
  const totalNewItemPrice = newItemProductPrice(obj);
  // calculate positive negative quotation discount value
  const discountValue = (totalNewItemPrice * (projectDetails.discountPercent/ 100)).toFixed(2);
  // calculate positive negative quotation subTotal value
  const subTotalValue = parseInt(totalNewItemPrice - discountValue);
  // calculate positive negative quotation GST 18% value
  const gstAmount = ((18 / 100) * subTotalValue).toFixed(2);
  // calculate positive negative quotation Total value
  const totalValue = parseInt(subTotalValue + parseInt(gstAmount));

  setAddRemoveTotalValue(totalNewItemPrice); // TOTAL amount whatever we are only adding and removig from quotation on post designsignoff category change
  setTotalValueBeforeAddCategory(totalValue); // In total section before removing value from category the total value is storing
  calculateBalnceSheetAmount(totalNewItemPrice); // calculation all amount of BalanceSheet/c
  setNewChangesTotalProductsPrice(prevState => ({...prevState,totalQuotationValue: totalNewItemPrice, discount : discountValue, subTotal : subTotalValue , gst18PerAmount : gstAmount , total : totalValue}));
  setQtPreview(obj);
  // Here I am storing only new Item adding selection option new itme and catrgory new Item to store in projectProduct collection
  const d1 = obj.filter(data => data.spacename === 'POST DESIGN SIGN-OFF CHANGES').map((data, i) => {
  const data1 = data.product.filter((item)=> item?.categoryQtData || item.prevQtData) 
    return data1;
  })
  setqtPreviewOnlyNewData(d1[0]);

    obj.filter(data => data.spacename === 'POST DESIGN SIGN-OFF CHANGES').map((data, i) => {
    const filteredProducts = data?.product?.filter(item => item?.negativeQtCr);
      if(totalNewItemPrice < 0){
      SetUploadPaymentButtonVisibility(true)
      setSendForApprovalDisable(false)
    } else {
      SetUploadPaymentButtonVisibility(false)
      setSendForApprovalDisable(true)
    }
});

// this is for balance sheet data to know how many nee item added
  if (
    projectDetails.contractCustomerApproved &&
    projectDetails.contractFinanceApproved &&
    projectDetails.designStages === 'Design Sign-off'
  ) {

    let extractedData = [];

    obj
      .filter(data => data.spacename === 'POST DESIGN SIGN-OFF CHANGES')
      .forEach(data => {
        // Inside the forEach loop, filter the product array
        const filteredProducts = data?.product?.filter(
          item => item?.negativeQtCr || item?.positiveQtCr
        );

        filteredProducts.forEach(product => {
          // Create an object containing only the name and productPrice fields
          const extractedProduct = {
            name: product.product.name,
            productPrice: product.productPrice,
            action: product.productPrice > 0 ? "Add" : "Less",
            scopeId: product.product.scopeId._id,
            productId: product?.product._id,
            finishType: product.finishType.description,
            unitType: product.unitType.name,
            length: product.length,
            width: product.width,
            area: product.area,
            totalPrice: product.productPrice,
            pricePerUnit: product.productPricePerUnit
          };
          // Push the extracted product object into the extractedData array
          extractedData.push(extractedProduct);
        });
        setNewItemAddedArray(extractedData)
      });
  }
  let miscIndex = -1;
  let dicountScope = [];
  let nonDicountScope = [];
  let categoryspecificTotal = []
  let discNElItemsArray = []
  let discElItemsArray = [];
  let discountOnAllScopeTrue = {};
  let discountOnAllScopeFalse = {};
  let spacesAndProducts = []
  let pdSpacesAndProducts = []
  let dummyproducts = []
  let complimentaryItems = []
  let approvedComplimentaryItems = []
  obj.forEach((preview) => {
    const productNamesInSpace = preview.product
      .flatMap((product) => product)
      .filter((product) => product?.product?.isComplimentaryItem)
      .map((product) => ({
        name: product.product.name,
        area: product.area
      }));
    spacesAndProducts?.push({
      spaceName: preview.spacename,
      productNames: productNamesInSpace
    })
  })
  spacesAndProducts.forEach((product) => {
    if (product.productNames && product.productNames.length != 0) {
      setComplimentaryItemPresent(true);
    }
  })

  projectDetails.complimentaryItems?.forEach((item) => {

    // Check if products array is not empty
    if (item.productNames && item.productNames.length > 0) {
      approvedComplimentaryItems.push({
        spaceName: item.spaceName,
        productNames: item.productNames
      })
      item.productNames.forEach((product) => {
        pdSpacesAndProducts.push({
          roomName: item.spaceName,
          qty: product.area,
          name: product.name,
          chApproved: product.chApproved,
          itemApproved: product.itemApproved
        });
      });
    }
  });

  obj.forEach((preview) => {
    preview.product.forEach((product) => {
      if (product?.product?.isComplimentaryItem) {
        dummyproducts.push({
          roomName: preview.spacename,
          name: product.product.name,
          qty: product.area
        })
      }
    })
  })
  obj.forEach((preview) => {
    const productNames = [];
    preview.product.forEach((product) => {
        if (product?.product?.isComplimentaryItem) {
            productNames.push({
                name: product.product.name,
                qty: product.area,
                chApproved: false
            });
        }
    });
    if (productNames.length > 0) {
      setComplimentaryItemPresent(true)
        complimentaryItems?.push({
            spaceName: preview.spacename,
            productNames: productNames
        });
    }
});
  for (let i = 0; i < dummyproducts.length; i++) {
    const componentItem = dummyproducts[i];
    let isNewRoomPresent = true; // Flag to check if a new room is present

    for (let j = pdSpacesAndProducts.length - 1; j >= 0; j--) {
      const pdItem = pdSpacesAndProducts[j];
      if (componentItem && pdItem) {
        // Check if the name of the componentItem is present in pdSpacesAndProducts
        const isNameNotPresent = pdSpacesAndProducts.every(pdItem => pdItem.name !== componentItem.name);
        // Check if the componentItem is present in pdSpacesAndProducts and approved
        if (componentItem.name === pdItem.name && componentItem.roomName === pdItem.roomName && pdItem.chApproved) {
          isNewRoomPresent = false; // Set to false as room exists
          // Check if qty and roomName match
          if (componentItem.qty === pdItem.qty && componentItem.roomName === pdItem.roomName) {
            break; // Break the loop if matched
          } else if (componentItem.qty !== pdItem.qty && componentItem.roomName === pdItem.roomName) {
            setComplimentaryItemRevoked(true);
          } else if (componentItem.roomName !== pdItem.roomName) {
            // setComplimentaryItemRevoked(true);
          }
        } else if (componentItem.name === pdItem.name && componentItem.roomName === pdItem.roomName && pdItem.chApproved === false) {
          setRejectedItem(true);
        }
        if (isNameNotPresent) {
          setNewComplimentaryItem(true)
        }
      }
    }
    // If a new room is present in dummyproducts and not in pdSpacesAndProducts, set the flag
    if (isNewRoomPresent) {
      setComplimentaryItemRevoked(true);
    }
  }
  
  for (let i = 0; i < sortedData.length; i++) {
    let price = 0;
    let discElItemsPrAmnt = 0;
    let discNElItemsPrAmnt = 0;
    sortedData[i]['products'].forEach(element => {
      if (element['product']?.['scopeId']?.['eligibleForDiscount'] === true) {
        dicountScope.push(element['product']?.['scopeId']?.['name']);
        setDiscountScopes(dicountScope);
      } else {
        nonDicountScope.push(element['product']?.['scopeId']?.['name']);
        setNonDiscountScopes(nonDicountScope);
      }
    });
    if (sortedData[i]['categoryId']['name'].toLowerCase() === 'miscellaneous') {
      miscIndex = i;
    }

    if (projectDetails.discountOnAllScopes === false) {
      sortedData[i]['products'].forEach(element => {
        if (element['product']?.['scopeId']?.['eligibleForDiscount'] === true) {
          discElItemsPrAmnt = discElItemsPrAmnt + Number(element['productPrice'])
          discElItemsArray.push(discElItemsPrAmnt)
        } else if (element['product']?.['scopeId']?.['eligibleForDiscount'] === false) {
          discNElItemsPrAmnt = discNElItemsPrAmnt + Number(element['productPrice'])
          discNElItemsArray.push(discNElItemsPrAmnt)
        }
      });
      setDisCountEligibleItemsPriceAmount(discElItemsArray)
      setDisCountNonEligibleItemsPriceAmount(discNElItemsArray);
      categoryspecificTotal.push(Number(discNElItemsPrAmnt.toFixed(2)) + Number(discElItemsPrAmnt.toFixed(2)));
      setCategoryspecificTotal(categoryspecificTotal);
    } else if (projectDetails.discountOnAllScopes === true) {
      sortedData[i]['products'].forEach(element => {
        price = Number(price) + Number(element['productPrice']);
      });
      categoryspecificTotal.push(price)
      setCategoryspecificTotal(categoryspecificTotal);
    }
  }

  for (let i = 0; i < categoryspecificTotal.length; i++) {
    if (miscIndex === i) continue;
    priceAmount += categoryspecificTotal[i];
    totalDiscPrAmnt = discElItemsArray.reduce((a, b) => a + b, 0);
    totalNonDiscPrAmnt = discNElItemsArray.reduce((a, b) => a + b, 0);
    setTotalPaymentPrice(priceAmount);
    setTotalDescPerAmt(totalDiscPrAmnt);
    setTotalNonDescPerAmt(totalNonDiscPrAmnt);
  }

  if (projectDetails.discountOnAllScopes === true) {
    priceAmount = Number(priceAmount.toFixed(0));
    taxableAmount = Number((0.18 * priceAmount).toFixed(0));
    totalPayable = Number((priceAmount + taxableAmount).toFixed(0));
    discountOnAllScopeTrue.priceAmount = priceAmount;
    discountOnAllScopeTrue.taxableAmount = taxableAmount;
    discountOnAllScopeTrue.totalPayable = totalPayable;
    calDiscount(projectDetails.discountPercent, discountOnAllScopeTrue);
  } else {
    const uniqueDiscountScopes = Array.from(new Set(discountScopes));
    const uniqueNonDiscountScopes = Array.from(new Set(nonDiscountScopes));
    setEligibleDiscountScopes(uniqueDiscountScopes.length === 0 ? 'None' : uniqueDiscountScopes.join(','));
    setEligibleNonDiscountScopes(uniqueNonDiscountScopes.length === 0 ? 'None' : uniqueNonDiscountScopes.join(','));
    totalDiscPrAmnt = Number(totalDiscPrAmnt.toFixed(0));
    totalNonDiscPrAmnt = Number(totalNonDiscPrAmnt.toFixed(0));
    priceAmount = Number(totalDiscPrAmnt.toFixed(0)) + Number(totalNonDiscPrAmnt.toFixed(0));
    taxableAmount = Number((0.18 * priceAmount).toFixed(0));
    totalPayable = Number((priceAmount + taxableAmount).toFixed(0));
    discountOnAllScopeFalse.eligibleDiscountScopesList = uniqueDiscountScopes.length === 0 ? 'None' : uniqueDiscountScopes.join(',')
    discountOnAllScopeFalse.eligibleNonDiscountScopesList = uniqueNonDiscountScopes.length === 0 ? 'None' : uniqueNonDiscountScopes.join(',')
    discountOnAllScopeFalse.totalDiscPrAmnt = totalDiscPrAmnt;
    discountOnAllScopeFalse.totalNonDiscPrAmnt = totalNonDiscPrAmnt;
    discountOnAllScopeFalse.priceAmount = priceAmount;
    discountOnAllScopeFalse.taxableAmount = taxableAmount;
    discountOnAllScopeFalse.totalPayable = totalPayable;
    calDiscount(projectDetails.discountPercent, discountOnAllScopeFalse);
  }

  if(projectDetails?.sentForQuotationChangeApproval?.checkQtCrAmount?.valuesGreaterThan20k === false && projectDetails?.delayCategoryCheck === false){
    setFinalizeButtonVisibility(true);
  } else{
    setFinalizeButtonVisibility(false);
  }
}
// calculate balance sheet data
const calculateBalnceSheetAmount = (total)=> {

  let prevquotationTotalAmount;
  if (projectDetails?.sentForQuotationChangeApproval?.isSendForApproval) {
    SetQuotationTotalAmount(Math.round(projectDetails?.prevQuotationTotalAmount))
    prevquotationTotalAmount = projectDetails?.prevQuotationTotalAmount;
  } else {
    prevquotationTotalAmount = quotationTotalAmount; // Assuming quotationTotal is the total amount from the quotation
  }
  
  const reviseQuotationValuesCount = parseInt(prevquotationTotalAmount +  total).toFixed(2) ;
  const  discountCount = (reviseQuotationValuesCount * (projectDetails.discountPercent /100)).toFixed(2);
  const subTotalCount  = parseInt(reviseQuotationValuesCount - discountCount);
  const gstCount = (subTotalCount * (18 /100)).toFixed(2);
  const totalCount = parseInt(subTotalCount + (+gstCount));
  getAmountPaid(totalCount)
  setBalansheSheetQtTotalPrice(totalCount);
  setBalanceSheetData((prev) => ({...prev , reviseQuotationValue : reviseQuotationValuesCount, discount: discountCount, subTotal: subTotalCount, GST : gstCount, total : totalCount}));
}
const calDiscount = (discntval, valueData) => {
  if (+discntval < 0) {
    // Display a warning message if the discount percentage is negative
    return props.setSnackInfo("Discount % can't be Negative", "warning");
  }

  // Normalize values
  const departmentName = projectDetails?.departmentId?.name?.toLowerCase() || "";
  const salesStage = projectDetails?.salesStage.toLowerCase() || "";

  // leadWonDate handling (important)
  const leadWonDate = projectDetails?.leadWonDate
    ? new Date(projectDetails.leadWonDate)
    : null;

  // Conditions
  const isLeadWonAfterCutoff =
    leadWonDate && leadWonDate >= cutoffDate;

  const isSalesOrMarketing =
    allowedDepartments.includes(departmentName);

  const isValidStage =
    !excludedStages.includes(salesStage);

  // FINAL DECISION
  let maxAllowed;

  if (isLeadWonAfterCutoff) {
    // Condition 1
    maxAllowed = discountMasterMaxApr26;

  } else if (isSalesOrMarketing && isValidStage) {
    // Condition 2
    maxAllowed = discountMasterMaxApr26;

  } else {
    // Default
    maxAllowed = discountMasterMax;
  }

  // VALIDATION
  if (+discntval > maxAllowed) {
    return props.setSnackInfo(
      `Cannot raise a discount request greater than ${maxAllowed}%.`,
      "warning"
    );
  }

  setChangeDiscount(discntval);
  let previousData;
  if (valueData !== 'val') {
    previousData = valueData
  }
  let materialProcPercent = projectDetails.materialProcuredPercent === null || projectDetails.materialProcuredPercent === undefined ? 0 : projectDetails.materialProcuredPercent;
  let amount = previousData === undefined ? totalPaymentPrice : previousData.priceAmount;
  let totalDiscPrice = previousData === undefined ? totalDescPerAmt : previousData.totalDiscPrAmnt;
  let totalNonDiscPrice = previousData === undefined ? totalNonDescPerAmt : previousData.totalNonDiscPrAmnt;
  if (projectDetails.discountOnAllScopes === false) {
    discountValue = (discntval / 100) * totalDiscPrice;
    discItemsSubTotal = totalDiscPrice - discountValue;
    subTotal = discItemsSubTotal + totalNonDiscPrice;
    scopePercentage = 100 - materialProcPercent;
    decorpotScope = parseInt(String((scopePercentage * subTotal) / 100));
    taxableAmount = parseInt(String(decorpotScope * 0.18));
    total = taxableAmount + decorpotScope;
    ctpAmount = parseInt(String((materialProcPercent * subTotal) / 100));
    totalPayable = parseInt(String(total + ctpAmount));
    customerSavings = parseInt(String((amount * 1.18) - totalPayable));
    savingPercen = Number((customerSavings * 100) / (1.18 * (totalDiscPrice + totalNonDiscPrice)).toFixed(2));

    let paymentInfo = {
      priceAmount: amount,
      discountPercent: Number(discntval),
      discountValue: discountValue.toFixed(2),
      subTotal: subTotal,
      scopePercentage: scopePercentage ? scopePercentage : 0,
      decorpotScope: decorpotScope ? decorpotScope : 0,
      taxableAmount: taxableAmount,
      total: total,
      savingPercen: savingPercen ? savingPercen : 0,
      customerSavings: customerSavings ? customerSavings : 0,
      discItemsSubTotal: discItemsSubTotal,
      totalNonDiscPrAmnt: totalNonDiscPrice
    }
    setPaymentTotalInfo(paymentInfo)
    setDiscountItemSubTotal(discItemsSubTotal);
  } else {
    discountValue = (discntval / 100) * amount;
    subTotal = amount - discountValue;
    scopePercentage = 100 - materialProcPercent;
    decorpotScope = parseInt(String((scopePercentage * subTotal) / 100));
    taxableAmount = parseInt(String(decorpotScope * 0.18));
    total = taxableAmount + decorpotScope;
    ctpAmount = parseInt(String(projectDetails.materialProcuredPercent * subTotal) / 100);
    totalPayable = parseInt(String(total + ctpAmount));
    customerSavings = parseInt(String((amount * 1.18) - totalPayable));
    savingPercen = Number(((customerSavings * 100) / (1.18 * amount)).toFixed(2));

    let paymentInfo = {
      priceAmount: amount,
      discountPercent: Number(discntval),
      discountValue: discountValue.toFixed(2),
      subTotal: subTotal,
      scopePercentage: scopePercentage ? scopePercentage : 0,
      decorpotScope: decorpotScope ? decorpotScope : 0,
      taxableAmount: taxableAmount,
      total: total,
      savingPercen: savingPercen ? savingPercen : 0,
      customerSavings: customerSavings ? customerSavings : 0
    }
    setPaymentTotalInfo(paymentInfo)
  }
}

const finalize = () => {
  // warning! when we clicked finalize button for some condition instead of disable button
const title = (!(discount <= discountMaster) && (discount !== projectDetails.discountPercent) || (projectDetails.discountStatus === "Rejected") && !(discount <= discountMaster) || (projectDetails.discountStatus === "Sent for approval")) &&
  ((complimentaryItemPresent && projectDetails.complimentaryItemStatus === "Not Initiated") || complimentaryItemRevoked || newComplimentaryItem || rejectedItem) ?
  "Complimentary Items & discount" :
  ((complimentaryItemPresent && projectDetails.complimentaryItemStatus === "Not Initiated") || complimentaryItemRevoked || newComplimentaryItem || rejectedItem) ?
    "Complimentary Items" : "discount"
if(!(discount <= discountMaster) && (discount !== projectDetails.discountPercent) || (projectDetails.discountStatus === "Rejected") && !(discount <= discountMaster) || (projectDetails.discountStatus === "Sent for approval")){
      props.setSnackInfo(`Please get ${title} approved from DGM/CenterHead`, "warning")
}
// else if (((complimentaryItemPresent && projectDetails.complimentaryItemStatus === 'Not Initiated') || complimentaryItemRevoked || newComplimentaryItem || rejectedItem) && userDetails.roles.find(role => role.name === ROLENAME.CHM_Manager || role.name === ROLENAME.CHM_User)) {
//   props.setSnackInfo("Please remove the newly added complimentary items in the quotation before finalizing it", "warning")
// }
// else if ((complimentaryItemPresent && projectDetails.complimentaryItemStatus === 'Not Initiated') || complimentaryItemRevoked || newComplimentaryItem || rejectedItem) {
//   props.setSnackInfo(`Please send the ${title} for approval before finalizing the quotation `, "warning")
// }
else{
let components = new Array();

if (material == null || material === undefined) {
  material = 0;
}
if (projectDetails.discountPercent == null || projectDetails.discountPercent === undefined) {
  setChangeDiscount(0)
}
projectComponents.forEach(element => {
  let w = 0;
  if (element?.['categoryId']?.['_id'] !== null || element?.['categoryId']?.['_id'] !== undefined) {
    let products = new Array();
    for (let i = 0; i < element['products'].length; i++) {
      products.push({
        finishType: element['products'][i]['finishType'] ? element['products'][i]['finishType']?.['_id'] : null,
        priority: Number(element['products'][i]['priority']),
        product: element['products'][i]['product']?.['_id'],
        length: element['products'][i]['length'] ? element['products'][i]['length'] : 0,
        width: element['products'][i]['width'] ? element['products'][i]['width'] : 0,
        // unitType: element['products'][i]['unitType'] == null ? element['products'][i]['product']['unitId'] : null,
        unitType: element['products'][i]['unitType']['_id'],
        area: Number(element['products'][i]['area']) ? Number(element['products'][i]['area']) : 0,
        productPrice: Number(element['products'][i]['productPrice']),
        productPricePerUnit: Number(element['products'][i]['productPricePerUnit']),
        totalPricePerUnit: Number(element['products'][i]['totalPricePerUnit']),
        subUnitType: element['products'][i]['subUnitType'],
        productCustomPrice: Number(element['products'][i]['productCustomPrice']),
        productCustomArea: Number(element['products'][i]['productCustomArea']),
        images: element['products'][i]['images']
      });
    }
    let obj1 = {
      categoryId: {
        _id: element?.['categoryId']?.['_id'],
        name: element?.['categoryId']?.['name']
      },
      products: products,
      projCompId: element['_id'],
      plyType: element?.['plyType']?.['_id'] ? element?.['plyType']?.['_id'] : defaultPlyType._id
    }
    w++;
    if (obj1.products.length === 0) {
    } else {
      components.push(obj1);
    }
  }
});
if (projectDetails.discountOnAllScopes === true) {

  let balanceSheetDataObj = {
    positiveNegativeCr : projectDetails?.sentForQuotationChangeApproval?.isSendForApproval ? true : false ,
    prevQuotationAmount: quotationTotalAmount,
    newItemAdded: newItemAddedArray,
    revisedQtAmount : balanceSheetData.reviseQuotationValue,
    discountAmount: balanceSheetData.discount,
    subTotalAmount: balanceSheetData.subTotal,
    gstAmount: balanceSheetData.GST,
    totalAmount: balanceSheetData.total,
    amountPaid: amountPaid,
    delayPenality: damageDelayOtherValue.delayPenality,
    damages: damageDelayOtherValue.damages,
    goodWillDiscount : damageDelayOtherValue.goodWillDiscount,
    other: damageDelayOtherValue.other,
    referralBonus: damageDelayOtherValue.referralBonus,
    pendingDueAmount: balanceSheetData.pendingDue
  }
  // console.log("balanceSheetDataObj11",balanceSheetDataObj)
  let obj = {
    leadId: leadId,
    taxPercent: 18,
    totalAmount: totalPaymentPrice,
    discountOnAllScopes: projectDetails.discountOnAllScopes,
    totalDiscPrAmnt: 0,
    discItemsSubTotal: 0,
    totalNonDiscPrAmnt: 0,
    miscTotal: 0,
    version: projectDetails.nextVersionNo,
    components: components,
    discountPercent: Number(paymentTotalInfo.discountPercent),
    grandTotal: Number(paymentTotalInfo?.total?.toFixed(2)),
    materialProcured: projectDetails.materialProcuredPercent !== null ? projectDetails.materialProcuredPercent : 0,
    paymentReceiptArray:  projectDetails?.sentForQuotationChangeApproval?.paymentReceiptArray,
    staticDesignWonAmount : Number(paymentTotalInfo.total.toFixed(2)),
    balanceSheetData: (projectDetails?.sentForQuotationChangeApproval?.isSendForApproval ? balanceSheetDataObj :{} )

  }

let companyDataObject ={
  leadId:leadId,
  taxPercent : 18,
  totalPrice: Math.round(totalPaymentPrice),
  discount : Math.round((Number(totalPaymentPrice) * (Number(paymentTotalInfo.discountPercent)/100))) ,
  gst:  ((totalPaymentPrice - (Number(totalPaymentPrice) * (Number(paymentTotalInfo.discountPercent)/100))) * (18/100)).toFixed(2),
  grandTotal : Math.round(paymentTotalInfo?.total?.toFixed(2)),
  customerOutflow : Number(paymentTotalInfo?.total?.toFixed(2)),
  projectId: projectDetails.erpProjectId,
  newTemAddedDataArray : qtPreviewOnlyNewData,
}
  finalizeQuotation(obj, companyDataObject);
} else {

    let balanceSheetDataObj = {
      positiveNegativeCr : projectDetails?.sentForQuotationChangeApproval?.isSendForApproval ? true : false ,
      prevQuotationAmount: quotationTotalAmount,
      newItemAdded: newItemAddedArray,
      revisedQtAmount : balanceSheetData.reviseQuotationValue,
      discountAmount: balanceSheetData.discount,
      subTotalAmount: balanceSheetData.subTotal,
      gstAmount: balanceSheetData.GST,
      totalAmount: balanceSheetData.total,
      amountPaid: amountPaid,
      delayPenality: damageDelayOtherValue.delayPenality,
      damages: damageDelayOtherValue.damages,
      goodWillDiscount : damageDelayOtherValue.goodWillDiscount,
      other: damageDelayOtherValue.other,
      referralBonus: damageDelayOtherValue.referralBonus,
      pendingDueAmount: balanceSheetData.pendingDue
    }
  let obj = {
    leadId: leadId,
    taxPercent: 18,
    discountOnAllScopes: projectDetails.discountOnAllScopes,
    eligibleDiscountScopes: eligibleDiscountScopes,
    eligibleNonDiscountScopes: eligibleNonDiscountScopes,
    totalAmount: discountItemSubTotal + totalNonDescPerAmt,
    totalDiscPrAmnt: totalDescPerAmt,
    discItemsSubTotal: discountItemSubTotal,
    totalNonDiscPrAmnt: totalNonDescPerAmt,
    miscTotal: 0,
    version: projectDetails.nextVersionNo,
    components: components,
    discountPercent: Number(paymentTotalInfo.discountPercent),
    grandTotal: Number(paymentTotalInfo.total.toFixed(2)),
    staticDesignWonAmount : Number(paymentTotalInfo.total.toFixed(2)),
    materialProcured: projectDetails.materialProcuredPercent !== null ? projectDetails.materialProcuredPercent : 0,
    paymentReceiptArray:  projectDetails?.sentForQuotationChangeApproval?.paymentReceiptArray,
    balanceSheetData: (projectDetails?.sentForQuotationChangeApproval?.isSendForApproval ? balanceSheetDataObj :{} )
  }
  // if (miscIndex > -1) {
  //   obj.totalAmount = Number(obj.totalAmount + categoryspecificTotal[miscIndex]);
  //   obj.miscTotal = Number(categoryspecificTotal[miscIndex]);
  //   obj.grandTotal = Number(paymentTotalInfo.totalPayable + categoryspecificTotal[miscIndex]);
  // }
  let companyDataObject ={
    leadId:leadId,
    taxPercent : 18,
    totalPrice: Math.round(totalPaymentPrice),
    discount : Math.round((Number(totalPaymentPrice) * (Number(paymentTotalInfo.discountPercent)/100))) ,
    gst:  ((totalPaymentPrice - (Number(totalPaymentPrice) * (Number(paymentTotalInfo.discountPercent)/100))) * (18/100)).toFixed(2),
    grandTotal : Math.round(paymentTotalInfo?.total?.toFixed(2)),
    customerOutflow : Number(paymentTotalInfo?.total?.toFixed(2)),
    projectId: projectDetails.erpProjectId,
    newTemAddedDataArray : qtPreviewOnlyNewData
  }
  finalizeQuotation(obj,companyDataObject);
}
}
}

const paymentUploadFile = async (e) => {
  props.setLoading(true);
  // setCircularLoader(true);
  const files = e.target.files;
  // Iterate over each selected file
  for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fd = new FormData();
      fd.append("file", file);
      try {
          const fileUploadRes = await HttpService.uploadFile(fd);
          if (fileUploadRes.data) {
              setAddPaymentReceiptFileUploaded(true);
          }
          setPaymentReceipt(fileUploadRes.data);
          // setPaymentReceiptArray(...fileUploadRes.data)
          setPaymentReceiptArray(prev => [...prev, fileUploadRes.data]);
      } catch (err) {
          props.setSnackInfo(
              err?.response?.data ?? "Something went wrong",
              "error"
          );
      }
  }
  setDisplayUploadReceiptMsg(false)
  props.setLoading(false);
  // setCircularLoader(false);
};

 // Quotation Changes Approval - When send for approval quotation to approver
 const sendForApproval = async()=> {
  await handleProductSelect1(addDataState);
  await saveQuotationChanges();
  let delayCategory = false;
  const { delayPenalityCheck, damagesCheck, goodWillDiscountCheck, otherCheck, referralBonusCheck } = damageDelayOtherValue;
  // console.log(delayPenalityCheck, damagesCheck, goodWillDiscountCheck, otherCheck, referralBonusCheck )
  if(delayPenalityCheck || damagesCheck || goodWillDiscountCheck || otherCheck || referralBonusCheck){
    delayCategory = true;
  }
  const obj = {
    leadId : leadId,
    expCenter : projectDetails.experienceCenterId,
    negativeCR : 0,                                                                                                                       
    contractFinanceApproved : projectDetails.contractFinanceApproved,
    contractCustomerApproved : projectDetails.contractCustomerApproved,
    designStages : projectDetails.designStages,
    currentStage : projectDetails.currentStage,
    qtAmountCheck  : sendApprovalQtCrValue,
    cloneSelectedIndex : editQt, 
    paymentReceiptArray: paymentReceiptArray,
    discountPercentage: paymentTotalInfo.discountPercent,
    newQuotationAmount: parseFloat(paymentTotalInfo.total).toFixed(2),
    prevQuotationAmount : parseFloat(prevQtTotalAmount).toFixed(2),
    diffQtChanges : parseFloat(diffQtChanges).toFixed(2),
    damagetoReferralCategory:damageDelayOtherValue,
    onlyQuotationAmount : parseInt(newChangesTotalProductsPrice.total), //only normal quotation calculation total value
    balnceSheetPendingDueTotal : parseFloat(balanceSheetData.pendingDue), //balnce sheet total value
    amountPaid : parseFloat(amountPaid),  
    delayCategoryCheck : delayCategory,
    totalAmountOfCategory : delayToReferralCategoryTotal, 
    amountPaid : amountPaid,
    prevQuotationTotalAmount : quotationTotalAmount//total amount of only category item from damage till bonus item
    }
    // console.log("Object",obj)
  quotationChangesApproval(obj);
}

// const updateCompanyData = async (obj) => {
//   props.setLoading(true)
//     const companyPLData = await HttpService.updateCompanyPLData(obj);
//     if(companyPLData.status === 200){
//       console.log("company pl data updated")
//     }
//     else {
//       props.setSnackInfo('Something went wrong', "error")
//     }
//   props.setLoading(false)
// }

const finalizeQuotation = async (val,companyObj) => {
  props.setLoading(true)
  // if((projectDetails.contractCustomerApproved && projectDetails.contractFinanceApproved && projectDetails.designStages === 'Design Sign-off')){
  //   await updateCompanyData(companyObj);
  // }

  // this is for if adding damange or delay penality also from quotation change request
  let newItemArray = [];
  companyObj.newTemAddedDataArray.forEach(product => {
    const extractedProduct = {
      name: product.product.name,
      productPrice: product.productPrice,
      action: product.productPrice > 0 ? "Add" : "Less",
      scopeId: product.product.scopeId._id,
      productId: product?.product._id,
      finishType: product.finishType.description,
      unitType: product.unitType.name,
      length: product.length,
      width: product.width,
      area: product.area,
      totalPrice: product.productPrice,
      pricePerUnit: product.productPricePerUnit
    };
    newItemArray.push(extractedProduct);
  });

  val.balanceSheetData.newItemAdded = newItemArray

  const saveQuotationResponse = await HttpService.saveQuotation(val);
  if (saveQuotationResponse.status === 200) {
    props.setSnackInfo('Quotation saved successfully', "success")
    getAllQuotationsForProject(leadId)
    setOpenPreviewModal(false);
  } else {
    props.setSnackInfo('Something went wrong', "error")
  }
  props.setLoading(false)
}

// Send data for approval
const quotationChangesApproval = async (val) => {
  props.setLoading(true)
  const response = await HttpService.quotationChangesApproval(val);
  if (response.status === 200) {
    props.setSnackInfo('Quotation Sent for Approval', "success")
    getAllQuotationsForProject(leadId);
    setOpenPreviewModal(false);
  } else {
    props.setSnackInfo('Something went wrong', "error")
  }
  window.location.reload(true);
  props.setLoading(false)
}

const removeCategoryFromList = async (id, name) => {
  props.setLoading(true)
  const deleteProjectComponentResponse = await HttpService.deleteProjectComponent(id);
  if (deleteProjectComponentResponse.status === 200) {
    props.setSnackInfo('Project Component Deleted successfully', "success")
    getAllRooms()
    getProjectComponent()
    getAllProductsFromRateCard()
    setShowCreateQuotationModal(true)
    let projectProducts = { ...projectComponentProducts };
    delete projectProducts[name];
    setValue(null)
    setProjectComponentProducts(projectProducts);
  } else {
    props.setSnackInfo('Something went wrong', "error")
  }
  props.setLoading(false)
}

const getUnitByIdFunc = (val) => {
  if (val === constantUnitTypeMaster.Sqft) {
    return 'Sqft';
  }
  else {
    return 'mm';
  }
}

const unitChange = (v) => {
  let projectProducts = { ...projectComponentProducts }
  let unitSelect = v === null ? defaultUnitType : v
  let unitName = v?.name
  projectProducts[chosenCategory]['item'].forEach(async (ele, i) => {

    if(Number(ele['width']) < defaultDimension[`${unitName}`])
    {
      (ele['width']) = Number(defaultDimension[`${unitName}`])
    }

    if(Number(ele['length']) < defaultDimension[`${unitName}`])
    {
      (ele['length']) = Number(defaultDimension[`${unitName}`])
    }

    if(Number(ele['depth']) < defaultDimension[`${unitName}`])
    {
      (ele['depth']) = Number(defaultDimension[`${unitName}`])
    }

    
    if (falseCeilingValidate(ele['product']['name']))
    {
      if (unitSelect.name === 'Sqft') {
        ele['unitType'] = constantUnitTypeMaster.Sqft; // sqft unit id
        if(ele['product']['unitType'] == rftUnitTypeId || ele['product']['name'].toLowerCase().includes('rafter'))
        {
          ele['area'] = Number(ele['length']) * 3
        }
        else if(ele['product']['name'].includes('False ceiling (Peripheral with Cove'))
        {
          ele['area'] = ((Number(ele['width']) + Number(ele['length'])) * (Number(ele['depth']) + 3)) * 2
        }
        else if(ele['product']['name'].includes('False ceiling (Peripheral, No Cove'))
        {
          ele['area'] = ((Number(ele['width']) + Number(ele['length'])) * (Number(ele['depth']) + 1)) * 2
        }
        else if(ele['product']['name'].includes('False ceiling (Island with Cove'))
        {
          ele['area'] = (Number(ele['width']) * Number(ele['length'])) + ((Number(ele['width']) + Number(ele['length'])) * 6)
        }
        else if(ele['product']['name'].includes('False ceiling (Island, No Cove'))
        {
          ele['area'] = (Number(ele['width']) * Number(ele['length'])) + ((Number(ele['width']) + Number(ele['length'])) * 2)
        } 
        else if(ele['product']['name'].includes('False ceiling in Plywood'))
        {
          ele['area'] = (Number(ele['width']) * Number(ele['length'])).toFixed(2);
        }
        else
        {
          ele['area'] = (Number(ele['length']) + Number(ele['width'])) * 9;
          ele['area'] = Number(ele['area']).toFixed(2);
        }
        
      } else if (unitSelect.name === 'mm') {
        ele['unitType'] = constantUnitTypeMaster.mm; // mm unit id
        if(ele['product']['unitType'] == rftUnitTypeId || ele['product']['name'].toLowerCase().includes('rafter'))
        {
          ele['area'] = Number(((Number(ele['length']) * 3) / 300).toFixed(2))
        }
        else if(ele['product']['name'].includes('False ceiling (Peripheral with Cove'))
        {
          ele['area'] = Number(((((Number(ele['width']) + Number(ele['length'])) * (Number(ele['depth']) + 900)) * 2) / 90000).toFixed(2))
        }
        else if(ele['product']['name'].includes('False ceiling (Peripheral, No Cove'))
        {
          ele['area'] = Number(((((Number(ele['width']) + Number(ele['length'])) * (Number(ele['depth']) + 300)) * 2) / 90000).toFixed(2))
        }
        else if(ele['product']['name'].includes('False ceiling (Island with Cove'))
        {
          ele['area'] = Number((((Number(ele['width']) * Number(ele['length'])) + ((Number(ele['width']) + Number(ele['length'])) * 1800)) / 90000).toFixed(2))
        }
        else if(ele['product']['name'].includes('False ceiling (Island, No Cove'))
        {
          ele['area'] = Number((((Number(ele['width']) * Number(ele['length'])) + ((Number(ele['width']) + Number(ele['length'])) * 600)) / 90000).toFixed(2))
        } else if(ele['product']['name'].includes('False ceiling in Plywood'))
        {
          ele['area'] = Number((((Number(ele['width']) * Number(ele['length']))/300).toFixed(2)))
          ele['area'] = projectProducts[chosenCategory]['item'][i]['area'] / 300;
        }
        else
        {
          ele['area'] = ((Number(ele['length']) + Number(ele['width'])) * 9) / 300;
          ele['area'] = Number(ele['area']).toFixed(2);
        }
      }
    }
    else if(ele['product']['name'] == "Granite - Material + Fixing (Min order quantity 20 sft)")
    {
      if(unitSelect.name == 'Sqft')
      {
        ele['width'] = 2.5
        ele['area'] = Number(((Number(ele['length']) * Number(ele['width']))).toFixed(2))
        ele['unitType'] = constantUnitTypeMaster.Sqft;
      }
      else if(unitSelect.name == 'mm')
      {
        ele['width'] = 750
        ele['area'] = Number(((Number(ele['length']) * Number(ele['width']))/ 90000).toFixed(2))
        ele['unitType'] = constantUnitTypeMaster.mm;
      }
    }
    else if(ele['product']['name'] == "Granite for Island Counter - Material  + Fixing (Min order quantity 20 sft)")
    {
      if(unitSelect.name == 'Sqft')
      {
        
        ele['area'] = Number((((Number(ele['length']) + 1) * (Number(ele['width']) + 1))).toFixed(2))
        ele['unitType'] = constantUnitTypeMaster.Sqft;
      }
      else if(unitSelect.name == 'mm')
      {
        
        ele['area'] = Number((((Number(ele['length']) + 300) * (Number(ele['width']) + 300))/ 90000).toFixed(2))
        ele['unitType'] = constantUnitTypeMaster.mm;
      }
    }
    else
    {
      if (ele['subUnitType'] === 'Area') {     //condition for all products
        if (unitSelect.name === 'Sqft') {
          // eslint-disable-next-line default-case
          switch (getUnitByIdFunc(ele.unitType)) {
            case 'Sqft':
              ele['area'] = (Number(ele['length']) * Number(ele['width']));
              ele['area'] = Number(ele['area']).toFixed(2);
              break;
            case 'mm':
              ele['area'] = (Number(ele['length']) * Number(ele['width']));
              ele['area'] = Number(ele['area']).toFixed(2);
              break;
          }
          ele['unitType'] = unitSelect._id; // sqft unit id
        } else if (unitSelect.name === 'mm') {
          switch (getUnitByIdFunc(ele.unitType)) {
            case 'Sqft':
              ele['area'] = (Number(ele['length']) * Number(ele['width'])) / 90000;
              ele['area'] = Number(ele['area'].toFixed(2));
              break;
            case 'mm':
              break;
          }
          ele['unitType'] = unitSelect._id; // mm unit id
        }
      } else { }
    }
    ele['productPrice'] = ele['totalPricePerUnit'] * ele['area'];
    ele['productPrice'] = Number(ele['productPrice'].toFixed(2));
    ele.changePrice = ele['productPrice'];
    ele.changeArea = ele.area;
  })
  setSelectedUnit(projectProducts[chosenCategory]['unitSelect'] = unitSelect)
  projectProducts[chosenCategory]['unitSelect'] = unitSelect
  setProjectComponentProducts(projectProducts)
}

const falseCeilingValidate = (name) => {    //Validation for false ceiling
let nm = name.split(' ');
if (nm[0].toLowerCase() === 'false' && nm[1].toLowerCase() === 'ceiling') {
  return true;
} else {
  return false;
}
}

const customArea = (i, val, custArea) => {
let projectProducts = { ...projectComponentProducts }
projectProducts[chosenCategory]['item'][i]['customArea'] = val.target.checked
if (val.target.checked) {
  projectProducts[chosenCategory]['item'][i].productCustomArea = Number(projectProducts[chosenCategory]['item'][i].area)?.toFixed(2);
  projectProducts[chosenCategory]['item'][i].area = 0;
} else {
  projectProducts[chosenCategory]['item'][i].productCustomArea = 0;
  projectProducts[chosenCategory]['item'][i]['area'] = Number((projectProducts[chosenCategory]['item'][i]['width']) + Number(projectProducts[chosenCategory]['item'][i]['length']) * 9).toFixed(2);
  if (projectProducts[chosenCategory]['unitSelect']['name'] === 'mm') {
    projectProducts[chosenCategory]['item'][i]['area'] = projectProducts[chosenCategory]['item'][i]['area'] / 300;
    projectProducts[chosenCategory]['item'][i]['area'] = Number(projectProducts[chosenCategory]['item'][i]['area']).toFixed(2);
  }
}
setProjectComponentProducts(projectProducts)
}

const { name, email, contact_no, projectType, propertyType, scopeOfWork, description, floorPlan, isRegistered, area, leadType, discountOnAllScopes, assignTo, assignToManager } = projectDetailsFields

const changeHandler = (e) => {
  setProjectDetailsFields({
    ...projectDetailsFields, [e.target.name]: e.target.value,
  })
}

const saveProjectDetail = async () => {
  let obj = {
    ...projectDetailsFields,
    'customerId': projectDetails.customerId._id,
    'customer_no': projectDetails.customerId.customer_no,
    'area': projectDetails.area,
    'city': projectDetails.city._id,
    'experienceCenterId': projectDetails.experienceCenterId._id,
    'startInteriors': projectDetails.startInteriors
  }
  props.setLoading(true)
  try {
    const response = await HttpService.createNewProjectForAdditionalQuotation(obj)
    setEditProjectModal(false);
    props.setSnackInfo(response.data, "success")
  } catch (error) {
    props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
  }
  props.setLoading(false)
}

const editAmount = (e) => {
  const originalValue = parseFloat(e.target.value); // Convert the input value to a number
  const newValue = originalValue.toFixed(2); // Format to two decimal places

  if (originalValue > 0) { // Compare the original value
    setStoreTenPercentAmount({ amount: parseFloat(newValue) }); // Convert the string back to a number
  } else {
    props.setSnackInfo("Payment cannot be less than 1", "warning");
  }
};

const changeEditQuotation = async (data) =>{
  setPrevQtTotalAmount(data?.grandTotal?.toFixed(2))
  let lastVersion = quotationList[quotationList.length - 1];
  let obj = {
    versionId: (data?.designQuotationVersionId ? data?.designQuotationVersionId?._id : lastVersion._id),
    leadId: leadId,
    lastVersionNo: lastVersion.version,
  }
  props.setLoading(true)
  try {
    let res =  await HttpService.cloneSelectedQuotation(obj);                                                                               
    SetQuotationTotalAmount(Math.round(res.data.quotationTotalAmount));
    getAllQuotationsForProject(leadId);
  } catch (error) {
    props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
  }
  // setEditQt(i);
  props.setLoading(false);
}

let categoryObjDataArray = [];
const calculateDamageDelayOtherValue = (value,e)=> {
  categoryObjDataArray = [...addDataState]
  let object = {
    isDelete: false,
    docType: "ProductMaster",
    priority: 1,
    itemId: {
      code: "0",
      createdAt : "2024-04-18T11:52:59.669+0000",
      deleted : false,
      depth: 0,
      length: 0,
      width : 0,
      description : "",
      finishInclude : false,
      isActive : true,
      isCHApproval : false,
      isComplimentaryItem : false,
      moqInSqft : 1,
      name : "",
      newpricePerUnit : 0,
      orderType : "Project",
      plyInclude : false,
      pricePerUnit : 0,
      priority: 0,
      quantity: 0,
      scopeId: "662752df73828b62cb2de79b",
      status: "Active",
      sublinitTune: 'mm',
      unitId: "61338464h421454h9dd7d86c",
      updatedAt: "2024-04-17T05:37:50.599+0000",
      _v: 0,
      subUnitType: "Qty",
      _id: ""
    },
    projectRCMasterId : "64d2380c4d94ac1a527b8815",
    rate : 0,
    _v:0,
    _id : "64d2380c4d94ac1a527b882a"
  }

  let obj = {...damageDelayOtherValue}
  if(e === 'Delay Penality'){
    object.itemId.description = e;
    object.itemId.name = e;
    object.itemId._id = "66278ef073828b62cb2de7b3";
    object.rate = +value;
    setDamageDelayOtherValue((prev) => ({...prev, delayPenality : +value}))
    obj.delayPenalityCheck = true ;
    obj.delayPenality = +value;
  } else if(e === 'Damages'){
    object.itemId.description = e;
    object.itemId.name = e;
    object.itemId._id = "6627b4ee73828b62cb2de7bf";
    object.rate = +value;
    setDamageDelayOtherValue((prev) => ({...prev, damages : +value}))
      obj.damages = +value;
      obj.damagesCheck = true;
  } else if(e === 'Good Will Discount'){
    object.itemId.description = e;
    object.itemId.name = e;
    object.itemId._id = "6627b58773828b62cb2de7c0";
    object.rate = +value;
    setDamageDelayOtherValue((prev) => ({...prev, goodWillDiscount : +value}))
    obj.goodWillDiscount = +value;
    obj.goodWillDiscountCheck = true;
  } else if(e === 'Other'){
    object.itemId.description = 'Others';
    object.itemId.name = e;
    object.itemId._id = "6627b5a673828b62cb2de7c1";
    object.rate = +value;
    setDamageDelayOtherValue((prev) => ({...prev, other : +value}))
    obj.other = +value;
    obj.otherCheck = true;
  } else if(e === 'Referral Bonus'){
    object.itemId.description = e;
    object.itemId.name = e;
    object.itemId._id = "6627b5e973828b62cb2de7c2";
    object.rate = +value;
    setDamageDelayOtherValue((prev) => ({...prev, referralBonus : +value}))
    obj.referralBonus = +value;
    obj.referralBonusCheck = true;
  }
    const existingItem = categoryObjDataArray.find(item => item.itemId.name === object.itemId.name);
    if (existingItem) {
        // Update the existing item with the new values
        const updatedArray = categoryObjDataArray.map(item => {
            if (item.itemId.name === object.itemId.name) {
                return object; // Replace the existing item with the new item
            }
            return item; // Keep other items unchanged
        });
        categoryObjDataArray = updatedArray;
    } else {
        categoryObjDataArray.push(object);
    }
    setAddDataState(categoryObjDataArray)
    calculateTotalValue(obj);
    // console.log("categoryObjDataArray",categoryObjDataArray)
}

const handleCheckBox = (e) => {
  setDamageDelayOtherValue((prev) => {
    let updatedState = { ...prev };

    switch (e) {
      case 'Delay Penality':
        updatedState = {
          ...updatedState,
          delayPenalityCheck: !prev.delayPenalityCheck,
          delayPenality: prev.delayPenalityCheck ? 0 : prev.delayPenality
        };
        calculateDamageDelayOtherValue(updatedState.delayPenality, e);
        break;
      case 'Damages':
        updatedState = {
          ...updatedState,
          damagesCheck: !prev.damagesCheck,
          damages: prev.damagesCheck ? 0 : prev.damages
        };
        calculateDamageDelayOtherValue(updatedState.damages, e);
        break;
      case 'Good Will Discount':
        updatedState = {
          ...updatedState,
          goodWillDiscountCheck: !prev.goodWillDiscountCheck,
          goodWillDiscount: prev.goodWillDiscountCheck ? 0 : prev.goodWillDiscount
        };
        calculateDamageDelayOtherValue(updatedState.goodWillDiscount, e);
        break;
      case 'Other':
        updatedState = {
          ...updatedState,
          otherCheck: !prev.otherCheck,
          other: prev.otherCheck ? 0 : prev.other
        };
        calculateDamageDelayOtherValue(updatedState.other, e);
        break;
      case 'Referral Bonus':
        updatedState = {
          ...updatedState,
          referralBonusCheck: !prev.referralBonusCheck,
          referralBonus: prev.referralBonusCheck ? 0 : prev.referralBonus
        };
        calculateDamageDelayOtherValue(updatedState.referralBonus, e);
        break;
      default:
        break;
    }
    // After updating state, call handlePendingDueValue with the updated state
    calculateTotalValue(updatedState);
    return updatedState;
  });
};

const calculateTotalValue = (obj) => {
  let total = 0;
  if (obj?.delayPenalityCheck) {
    total += obj.delayPenality;
  }
  if (obj?.damagesCheck) {
    total += obj.damages;
  }
  if (obj?.goodWillDiscountCheck) {
    total += obj.goodWillDiscount;
  }
  if (obj?.otherCheck) {
    total += obj.other;
  }
  if (obj?.referralBonusCheck) {
    total += obj.referralBonus;
  }
  
  // const totalValue = parseInt(totalValueBeforeAddCategory - total)
  // setNewChangesTotalProductsPrice(prevState => ({...prevState, total : totalValue}));

  const balnceSheetPendingDueTotal = parseInt((balansheSheetQtTotalPrice - amountPaid - total).toFixed(2));
  setBalanceSheetData((prev)=>({...prev, pendingDue: balnceSheetPendingDueTotal}))
  setDelayToReferralCategoryTotal(total);
  return total;
};

 // get total amount paid for this lead
 const getAmountPaid = async (totalBalanceSheetAmount) => {
  try {
    const res = await HttpService.getAmountPaid(leadId);
    setAmountPaid(res.data.totalPaymentReceived);

    let balnceSheetPendingDueTotal = 0;

    let data = projectDetails.sentForQuotationChangeApproval?.amountPaid
    if ((projectDetails?.delayToReferralBonusCategory?.totalAmountOfCategory !== undefined && projectDetails?.delayToReferralBonusCategory?.totalAmountOfCategory !== 0) || (data !== res.data.totalPaymentReceived) && (data !== 0 && data !== undefined)) {
      setAmountPaid(projectDetails.sentForQuotationChangeApproval?.amountPaid)
      balnceSheetPendingDueTotal = (totalBalanceSheetAmount - projectDetails.sentForQuotationChangeApproval?.amountPaid);
      balnceSheetPendingDueTotal = balnceSheetPendingDueTotal - projectDetails?.delayToReferralBonusCategory?.totalAmountOfCategory
    }
    else {
      balnceSheetPendingDueTotal = parseInt(totalBalanceSheetAmount - res.data.totalPaymentReceived).toFixed(2);
    }
    setBalanceSheetData((prev) => ({ ...prev, pendingDue: balnceSheetPendingDueTotal }));
  }
  catch (err) {
    console.log(err);
  }
}

const handleAmountPaid = (amountPaidValue)=> {
  setAmountPaid(amountPaidValue)
  const balnceSheetPendingDueTotal = Number(balansheSheetQtTotalPrice - amountPaidValue - delayToReferralCategoryTotal).toFixed(2)
  setBalanceSheetData((prev)=>({...prev, pendingDue: balnceSheetPendingDueTotal}));
}

const discountRequest = async (discVal) => {
  let obj = {
    discountPercent: Number(discVal),
    discountStatus: 'Sent for approval',
    discountApprovalRequest: true,
    leadId: leadId
  }
  props.setLoading(true)
  const discountApprovalResponse = await HttpService.discountApproval(obj, leadId);
  if (discountApprovalResponse.status === 200) {
    props.setSnackInfo('Discount request send successfully', "success")
  } else {
    props.setSnackInfo('Something went wrong', "error")
  }
  getAllQuotationsForProject()
  props.setLoading(false)
}

const revoke = async () => {
  let obj = {
    discountApprovalRequest: false
  }
  props.setLoading(true)
  const discountApprovalResponse = await HttpService.discountApproval(obj, leadId);
  if (discountApprovalResponse.status === 200) {
    props.setSnackInfo('Discount revoke successfully', "success")
  } else {
    props.setSnackInfo('Something went wrong', "error")
  }
  getAllQuotationsForProject()
  props.setLoading(false)
}

  useEffect(() => {
    getDepartments();
    getUserdata();
    getSourceOfLeadData();
  }, []);

  const getUserdata = async () => {
    const users = await HttpService.getAllMangers();
    setUsersData(users.data);
  };

  const getSourceOfLeadData = async () => {
    const users = await HttpService.getLeadMaster();
    setSourceOfLeadData(users.data);
    props.setSnackInfo("Please search lead to raise positive negative CR request","success")
  };

  const getSalesUser = (item) => {
    let salesDataObj = {
      sales_user: "",
      sales_teamId: "",
      sales_manager: "",
    };

    if (item?.assignTo?.roles.find((ele) => ele.name === ROLENAME.SalesUser)) {
      salesDataObj.sales_user = item?.assignTo?.name;
      salesDataObj.sales_teamId = item?.assignTo?.teamId;
    }
    for (let i = 0; i < item?.previouslyAssignedTo?.length; i++) {
      for (let j = 0; j < item?.previouslyAssignedTo[i]?.roles.length; j++) {
        if (
          item.salesLeadOwnRole === "SalesUser" &&
          item?.previouslyAssignedTo[i]?.roles[j].name === ROLENAME.SalesUser
        ) {
          salesDataObj.sales_user = item?.previouslyAssignedTo[i]?.name;
          salesDataObj.sales_teamId = item?.previouslyAssignedTo[i]?.teamId;
        } else if (
          item.salesLeadOwnRole === "SalesManager" &&
          item?.previouslyAssignedTo[i]?.roles[j].name === ROLENAME.SalesManager
        ) {
          salesDataObj.sales_manager = item?.previouslyAssignedTo[i]?.name;
          salesDataObj.sales_user = "NA";
        }
      }
    }

    if (
      item?.assignTo?.roles.find((ele) => ele.name === ROLENAME.SalesManager)
    ) {
      salesDataObj.sales_manager = item?.assignTo?.name;
    }
    return salesDataObj;
  };

  const setHandleSearchedByEnter = (e) => {
    if (e.keyCode === 13) {
      setSearched(searchInput);
      requestSearch(selectedSearchType, searchInput);
    }
  };
  // click button seach on table view ribbon
  const setHandleSearched = (value) => {
    setSearched(value);
    requestSearch(selectedSearchType, value);
  };

  const requestSearch = async (searchType, search) => {
    props.setLoading(true);
    try {
      let data = {};
      data.role = "others";
      props.setLoading(true);
      const response = await HttpService.getRefundRequestSearchLeads(
        searchType.name,
        search,
        userDetails.selectedExpCenter,
      );
      props.setLoading(false);
      if (response.data && response.data.totalDocs >= 0) {
          if(response.data.totalDocs === 0){
            let snackString = String(response.data.totalDocs) + " Leads Found!";
            props.setSnackInfo(snackString, "success");
          }
      }
      let i = 1;
      let userTableViewData = [];
      const assignUserList = [];
      response?.data?.docs?.forEach((ele) => {
        ele["projects"]?.forEach((item) => {
          let data = getSalesUser(item);
          item.serial = i++;
          let obj = {
            projectId: item?._id,
            name: item?.customerId?.name,
            lead_no: item?.lead_no,
            customerId: item?.customerId?._id,
            status: item?.status,
            erpProjectNo: item?.erpProjectNo ? item?.erpProjectNo : "-",
            currentStage: item?.currentStage,
            stage: item?.salesStage === "Won" ? item.designStages : item?.salesStage,
            assignTo: item?.assignTo?.name,
            departmentId: item?.departmentId._id,
            department: item?.departmentId?.name,
            totalCustomerOutflow: item?.grandTotal ? item?.grandTotal : `0`,
            reasonForLost: item?.currentStage === "Lost" ? item?.reasonForLost : "-",
            createdAt: moment(item?.createdAt).format("DD-MM-YYYY"),
            lastActivityDate: moment(item?.lastActivityDate).format( "DD-MM-YYYY"),
            uniqueLeadNumber: item?.uniqueLeadNumber,
            expectedSalesclosureDate: item?.expectedSalesclosureDate ? moment(item?.expectedSalesclosureDate).format("DD-MM-YYYY"): "NA",
            salesUser: data.sales_user !== "" ? data.sales_user : "NA",
            salesUserTeamId: data.sales_teamId,
            salesManagerName: data.sales_manager,
            expectedHandoverDate: moment(item?.expectedHandoverDate).format( "DD-MM-YYYY"),
            salesStage: item?.salesStage ? item?.salesStage : "-",
            designStages: item?.designStages ? item?.designStages : "-",
            designKickOffCustomerActionFromChm: item?.designKickOffCustomerActionFromChm,
            isRefundRequestSent: item?.isRefundRequestSent ? item?.isRefundRequestSent : "-",
            designLostApproval: item?.designLostApproval,
            salesLostApproval: item?.salesLostApproval,
            salesRefundRequestApproval: item?.salesRefundRequestApproval,
            designRefundRequestApproval: item?.designRefundRequestApproval,
            contractCustomerApproved: item?.contractCustomerApproved,
            contractFinanceApproved: item?.contractFinanceApproved,
            paymentReceiptArrayQtChanges: item?.paymentReceiptArrayQtChanges,
            sentForQuotationChangeApproval: item?.sentForQuotationChangeApproval,
            delayToReferralBonusCategory: item?.delayToReferralBonusCategory,
            delayCategoryCheck: item?.delayCategoryCheck,
            prevQuotationTotalAmount: item?.prevQuotationTotalAmount,
          };
          userTableViewData.push(obj);
          assignUserList.push(item.assignTo?.name);
        });
      });

      setQTProjectRows(userTableViewData);
      setProjectDetails(userTableViewData[0]);
      getAllQuotationsForProject(userTableViewData[0].projectId)
      setLeadId(userTableViewData[0].projectId);
    } catch (error) {
      console.log(error);
    }
    props.setLoading(false);
  };


  const getDepartments = async () => {
    try {
      const department = await HttpService.getDepartments();
      setDepartmentList(department?.data);
    } catch (error) {
      console.log(error, "get department error");
    }
  };

  const raiseRefundQrequest = (row,i)=>{
    console.log(row,i)
  }

  const handle_search_type_selection = (value) => {
    setSelectedSearchType(value);
    setSearchInput("");
  };

  return (
    <div>
         <div style={{ marginBottom: 20 }}>
        <h3 style={{ textAlign: "center" }}>Raise Positive Negative CR Dashboard</h3>
      </div>
      <Paper
        style={{ marginTop: "20px", marginBottom: "20px", padding: "20px" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            margin: "Auto",
          }}
        >
          {/* Search Type */}
          <TextField
            select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedSearchType}
            label="Search Type"
            name="searchType"
            onChange={(e) => handle_search_type_selection(e.target.value)}
            variant="outlined"
            style={{ width: "30%", marginRight: "2%" }}
            size="small"
          >
            {searchTypes.map((el) => (
              <MenuItem key={el.name} value={el}>
                {el.name}
              </MenuItem>
            ))}
          </TextField>

          {/* Search Input */}
          <TextField
            label="Enter the input"
            name="searched"
            size="small"
            value={searchInput}
            onKeyDown={setHandleSearchedByEnter}
            onChange={(e) => {
              setSearchInput(e.target.value);
            }}
            variant="outlined"
            style={{ width: "80%" }}
          />

          {/* Search Button */}
          {userDetails?.roles?.find(
            (role) =>
              role.name !== "Procurement Executive" &&
              role.name !== "Store Manager"
          ) && (
            <Button
              disabled={!selectedSearchType.name || !searchInput}
              variant="contained"
              color="primary"
              size="medium"
              style={{ alignSelf: "center", marginLeft: 20 }} // Added height
              className={classes.leadSearchButton}
              onClick={() => setHandleSearched(searchInput.toUpperCase())}
            >
              Search
            </Button>
          )}
        </div>
      </Paper>
      <Paper>
    <TableContainer component={Paper}>
          <Table
            className={classes.table}
            stickyHeader
            aria-label="sticky table"
          >
          {qtprojects.length > 0 &&
             <TableHead>
              <StyledTableRow>
                <StyledTableCell>Sr. No.</StyledTableCell>
                <StyledTableCell>Customer</StyledTableCell>
                <StyledTableCell>Lead No</StyledTableCell>
                <StyledTableCell>Unique Lead No</StyledTableCell>
                <StyledTableCell>Project No.</StyledTableCell>
                <StyledTableCell>Department</StyledTableCell>
                <StyledTableCell>Status</StyledTableCell>
                <StyledTableCell>Current Stage</StyledTableCell>
                <StyledTableCell>Assigned to</StyledTableCell>
                <StyledTableCell>Quotation Amount</StyledTableCell>
                <StyledTableCell>Action</StyledTableCell>
              </StyledTableRow>
            </TableHead>
          }
            <TableBody>
              {qtprojects
                .sort((a, b) =>
                  b.createdAt
                    .split("-")
                    .reverse()
                    .join()
                    .localeCompare(a.createdAt.split("-").reverse().join())
                )
                .map((row, i) => {
                  return (
                    <StyledTableRow key={i + 1}>
                      <StyledTableCell>{i + 1}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">
                        <Link
                          to={`/project-logs/${row.projectId}`}
                          style={{ color: "#000", textDecoration: "underline" }}
                        >
                          {row?.name}
                        </Link>
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row">{row?.lead_no}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">{row?.uniqueLeadNumber ? row?.uniqueLeadNumber: "NA"}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">{row?.erpProjectNo}</StyledTableCell>
                      <StyledTableCell component="th" scope="row"> {row?.department}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">{row?.status}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">{row?.currentStage}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">{row?.assignTo}</StyledTableCell>
                      <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(row?.totalCustomerOutflow)}</StyledTableCell>
                      <StyledTableCell>
                        {row?.contractCustomerApproved && row?.contractFinanceApproved && row?.designStages === "Design Sign-off" ? (
                           userDetails?.roles?.find(role => role?.name === ROLENAME?.DesignUser || role.name === ROLENAME?.CHM_User) &&
                            <Button
                              variant="contained"
                              color="primary" 
                              style={{marginTop: 10, float: "right"}} 
                              conosle
                              onClick={(e)=>openCreateQuotationModal(e,row?.sentForQuotationChangeApproval?.isSendForApproval ? "Go To Finalize" : "Raise Change Request")}
                            >
                              {row?.sentForQuotationChangeApproval?.isSendForApproval ? "Go To Finalize" : "Raise Change Request"}
                            </Button>
                        ) : (
                          "NA"
                        )}

                      {/* Create Quotation Modal */}
                        <Modal
                          title="Create Quotation"
                          centered
                          visible={showCreateQuotationModal}
                          onCancel={() => setShowCreateQuotationModal(false)}
                          width={1000}
                          maskClosable={false}
                          footer={null}
                         >
                          <Autocomplete
                            value={selectedCatergory}
                            onChange={(e, v) => handleCategorySelect(v)}
                            options={categoryList}
                            // getOptionLabel={(option) => option.name}
                            getOptionLabel={(option) => {
                              if (option.name === 'POST DESIGN SIGN-OFF CHANGES') {
                                return '';   // Return an empty string to hide this option
                              } else {
                                return option.name;
                              }
                            }}
                            style={{ width: 350, marginBottom: 10, display: (projectDetails.contractCustomerApproved && projectDetails.contractFinanceApproved && projectDetails.designStages === 'Design Sign-off') ? "none" : "" }}
                            renderInput={(params) => <TextField {...params} label="Select New Category" fullWidth variant="outlined" />}
                          />
                          <div style={{ float: "right", marginBottom: 10 }} >
                            <Button variant="contained" color="primary" style={{ marginRight: 5 }} onClick={() => saveQuotationChanges()} disabled={value === null || projectComponentProducts?.[chosenCategory]?.item.length === undefined || projectComponentProducts?.[chosenCategory]?.item.length === 0}>Save Changes</Button>
                            <Button variant="contained" color="primary" onClick={() => previewQuotation()} disabled={value === null || projectComponentProducts?.[chosenCategory]?.item.length === undefined || projectComponentProducts?.[chosenCategory]?.item.length === 0} >Preview Quotation</Button>
                          </div>
                          <div style={{ "margin-top": 20, display: (projectDetails.contractCustomerApproved && projectDetails.contractFinanceApproved && projectDetails.designStages === 'Design Sign-off') ? "none" : "" }}>
                            <span><b>Existing categories in quotation</b></span>
                          </div>
                          <AppBar position="static" color="default" style={{ marginBottom: 25 }}>
                            <Tabs
                              value={value}
                              onChange={handleChange}
                              onDoubleClick={() => handleDoubleClick(value)}
                              variant="scrollable"
                              scrollButtons="on"
                              indicatorColor="primary"
                              textColor="primary"
                              aria-label="scrollable force tabs example"
                            >
                              {projectDetails.contractCustomerApproved &&
                                projectDetails.contractFinanceApproved &&
                                projectDetails.designStages === 'Design Sign-off' ?
                                (projectComponents.map(comp =>
                                  <Tab
                                    style={{ display: comp?.categoryId?.name === 'POST DESIGN SIGN-OFF CHANGES' ? "" : "none" }}
                                    label={"Post Design Sign-off Changes"}
                                  />
                                )) :
                                (projectComponents.map(comp =>
                                  <Tab
                                    label={comp?.categoryId?.name}
                                  // icon={<DeleteForeverIcon style={{ cursor: "pointer", color: 'red', fontSize: "15px", borderBottom: "2px solid #000", marginBottom: "20px" }} onClick={() => removeCategoryFromList(comp._id)} />}
                                  />
                                ))
                              }
                            </Tabs>
                          </AppBar>
                          {value !== null && <>
                            <div style={{ marginTop: 10, marginBottom: 10, display: "flex", justifyContent: "space-between" }} >
                              <Button variant="contained" color="secondary" onClick={() => removeCategoryFromList(chosenCategoryId, chosenCategory)}
                                style={{ display: (projectDetails.contractCustomerApproved && projectDetails.contractFinanceApproved && projectDetails.designStages === 'Design Sign-off') ? "none" : "" }}>
                                Delete Category
                              </Button>
                            </div>
                            <div style={{ marginTop: 10, marginBottom: 10, display: "flex", justifyContent: "space-between" }}>
                              {/* Product Material Select  */}
                              <Autocomplete
                                onChange={(e, v) => handleProductSelect(v)}
                                options={productsList}
                                disabled={projectDetails?.sentForQuotationChangeApproval?.isSendForApproval}
                                getOptionLabel={(options) => options?.itemId?.name}
                                style={{ width: 350, marginBottom: 10 }}
                                renderInput={(params) => <TextField {...params} label="Add Items" fullWidth variant="outlined" size="small" />}
                              />
                              {/* Unit Changes */}
                              <Autocomplete
                                value={projectComponentProducts?.[chosenCategory]?.unitSelect}
                                disabled={projectDetails?.sentForQuotationChangeApproval?.isSendForApproval}
                                onChange={(e, v) => unitChange(v)}
                                options={unitList}
                                getOptionLabel={(option) => option?.name}
                                style={{ width: 350, marginBottom: 10 }}
                                renderInput={(params) => <TextField {...params} label="Choose Unit" fullWidth variant="outlined" size="small" />}
                              />
                              {/* Ply Select */}
                              <Autocomplete
                                value={projectComponentProducts?.[chosenCategory]?.plyType}
                                disabled={projectDetails?.sentForQuotationChangeApproval?.isSendForApproval}
                                onChange={(e, v) => handlePlySelect(v)}
                                options={plyList}
                                getOptionLabel={(option) => option?.name}
                                style={{ width: 350, marginBottom: 10 }}
                                renderInput={(params) => <TextField {...params} label="Choose Ply" fullWidth variant="outlined" size="small" />}
                              />
                            </div>
                            <TableContainer component={Paper}>
                              <Table className={classes.table} size="small" aria-label="customized table">
                                <TableHead>
                                  <TableRow>
                                    <StyledTableCell>Sl No</StyledTableCell>
                                    <StyledTableCell>Name</StyledTableCell>
                                    <StyledTableCell>Priority</StyledTableCell>
                                    <StyledTableCell>Finish</StyledTableCell>
                                    <StyledTableCell>Price Per Unit</StyledTableCell>
                                    <StyledTableCell>No/Qty</StyledTableCell>
                                    <StyledTableCell>Depth</StyledTableCell>
                                    <StyledTableCell>Width</StyledTableCell>
                                    <StyledTableCell>Length</StyledTableCell>
                                    <StyledTableCell>Area(SqFt)/Qty</StyledTableCell>
                                    <StyledTableCell>Price</StyledTableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {projectComponentProducts.hasOwnProperty(chosenCategory) && projectComponentProducts?.[chosenCategory]?.item?.map((data, i) => {

                                    // if (['A0', 'A1', 'A2', 'A3', 'A4'].includes(data?.product?.code)) {
                                    //   return null; // Skip rendering this row
                                    // }
                                    return (

                                      <StyledTableRow key={i + 1}>
                                        <StyledTableCell component="th" scope="row">{i + 1}</StyledTableCell>
                                        {/* Name */}
                                        <StyledTableCell component="th" scope="row">
                                          <div style={{ display: "flex", justifyContent: "space-around" }}>
                                            <span>{data?.product?.name}</span>
                                            {/* <DeleteForeverIcon style={{ cursor: "pointer" }} onClick={() => removeItemFromList(i)} /> */}
                                            {(projectDetails.contractCustomerApproved &&
                                              projectDetails.contractFinanceApproved &&
                                              projectDetails.designStages === 'Design Sign-off')
                                              ?
                                              (projectDetails.contractCustomerApproved &&
                                                projectDetails.contractFinanceApproved &&
                                                projectDetails.designStages === 'Design Sign-off' &&
                                                data?.newItemAdded)
                                                ? (
                                                  <DeleteForeverIcon
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => removeItemFromList(i)}
                                                  />
                                                ) : (
                                                  <DeleteForeverIcon
                                                    style={{ cursor: "not-allowed", color: "grey" }}
                                                    onClick={() => { }}
                                                  />
                                                )
                                              :
                                              (<DeleteForeverIcon
                                                style={{ cursor: "pointer" }}
                                                onClick={() => removeItemFromList(i)}
                                              />
                                              )}
                                          </div>
                                        </StyledTableCell>
                                        {/* Priority */}
                                        <StyledTableCell component="th" scope="row">
                                          <TextField name="priority" size="small" value={Number(data.priority)}
                                            onKeyPress={(e) => sortPriorityData(e)}
                                            onBlur={(e) => sortPriorityOnOnBlur(e)}
                                            disabled={
                                              (projectDetails.contractCustomerApproved &&
                                                projectDetails.contractFinanceApproved &&
                                                projectDetails.designStages === 'Design Sign-off') &&
                                              (data?.newItemAdded ? false : true)
                                            }
                                            onChange={(e) => handleChangePriority(e, i)} type="number" style={{ marginBottom: 10 }} variant="outlined" />
                                        </StyledTableCell>
                                        {/* Finish Select */}
                                        <StyledTableCell component="th" scope="row">{(data.subUnitType === 'Area' && data?.product?.finishInclude) && <Autocomplete
                                          value={projectComponentProducts?.[chosenCategory]?.item[i]['finishType']}
                                          onChange={(e, v) => handleFinishSelect(v, i)}
                                          options={finshesList}
                                          getOptionLabel={(option) => option?.name}
                                          style={{ width: 150, marginBottom: 10 }}
                                          disabled={
                                            (projectDetails.contractCustomerApproved &&
                                              projectDetails.contractFinanceApproved &&
                                              projectDetails.designStages === 'Design Sign-off') &&
                                            (data?.newItemAdded ? false : true)
                                          }
                                          renderInput={(params) => <TextField {...params} label="Choose Laminate" fullWidth size="small" variant="outlined" />}
                                        />}</StyledTableCell>

                                        {/* Per unit for subtype Area and Qty */}
                                        {data.subUnitType === 'Area' ? <StyledTableCell component="th" scope="row">{data?.totalPricePerUnit}</StyledTableCell> : <StyledTableCell component="th" scope="row">{data?.totalPricePerUnit}</StyledTableCell>}

                                        {/* No/Qty */}
                                        {data?.product?.name.includes('TIles fixing charges for tiles') ? <StyledTableCell component="th" scope="row">
                                          <TextField name="fixingCharge" size="small"
                                            disabled={
                                              (projectDetails.contractCustomerApproved &&
                                                projectDetails.contractFinanceApproved &&
                                                projectDetails.designStages === 'Design Sign-off') &&
                                              (data?.newItemAdded ? false : true)
                                            }
                                            value={data?.fixingCharge}
                                            // onChange={((e) => e.target.value >= 1 ? handleAreaQtyChange(e, i, 'l') : 1}
                                            onChange={(e) => {
                                              const newValue = (
                                                projectDetails.contractCustomerApproved &&
                                                projectDetails.contractFinanceApproved &&
                                                projectDetails.designStages === 'Design Sign-off'
                                              ) ? handleAreaQtyChange(e, i, 'l') : (e.target.value >= 1 ? handleAreaQtyChange(e, i, 'l') : 1);
                                            }}
                                            type="number"
                                            style={{ marginBottom: 10 }}
                                            fullWidth
                                            variant="outlined" />
                                        </StyledTableCell> : <StyledTableCell component="th" scope="row">-</StyledTableCell>}

                                        {/* Depth */}
                                        {(data?.product?.name.includes('False ceiling (Peripheral with Cove') || data?.product?.name.includes('False ceiling (Peripheral, No Cove')) ? <StyledTableCell component="th" scope="row">
                                          <TextField
                                            onBlur={(e) => handleAreaQtyCheck(e, i, 'l')}
                                            onChange={(e) => handleAreaQtyChange(e, i, 'l')}
                                            name="depth" size="small" value={data?.depth}
                                            disabled={
                                              (projectDetails.contractCustomerApproved &&
                                                projectDetails.contractFinanceApproved &&
                                                projectDetails.designStages === 'Design Sign-off') &&
                                              (data?.newItemAdded ? false : true)
                                            }
                                            type="number" style={{ marginBottom: 10 }} fullWidth variant="outlined" />
                                        </StyledTableCell> : <StyledTableCell component="th" scope="row">-</StyledTableCell>}

                                        {/* Width */}
                                        {(data.subUnitType !== 'Area') || data?.product?.name.includes('TIles fixing charges for tiles') || data?.product?.unitType == rftUnitTypeId || data?.product?.name.toLowerCase().includes('false ceiling rafter') ?
                                          <StyledTableCell component="th" scope="row">-</StyledTableCell> :
                                          <StyledTableCell component="th" scope="row">
                                            <TextField
                                              onBlur={(e) => handleAreaQtyCheck(e, i, 'l')}
                                              onChange={(e) => handleAreaQtyChange(e, i, 'l')}
                                              disabled={data?.product?.name.includes("Granite - Material + Fixing (Min order quantity 20 sft)")
                                                || (projectDetails.contractCustomerApproved &&
                                                  projectDetails.contractFinanceApproved &&
                                                  projectDetails.designStages === 'Design Sign-off') &&
                                                (data?.newItemAdded ? false : true)}
                                              name="width" size="small" value={data?.width}
                                              type="number" style={{ marginBottom: 10 }} fullWidth variant="outlined" />
                                          </StyledTableCell>}

                                        {/* Length */}
                                        {(data.subUnitType !== 'Area') || data?.product?.name.includes('TIles fixing charges for tiles') ? <StyledTableCell component="th" scope="row">-</StyledTableCell> : <StyledTableCell component="th" scope="row">
                                          <TextField
                                            onBlur={(e) => handleAreaQtyCheck(e, i, 'l')}
                                            onChange={(e) => handleAreaQtyChange(e, i, 'l')}
                                            name="length" size="small" value={data?.length}
                                            disabled={
                                              (projectDetails.contractCustomerApproved &&
                                                projectDetails.contractFinanceApproved &&
                                                projectDetails.designStages === 'Design Sign-off') &&
                                              (data?.newItemAdded ? false : true)
                                            }
                                            type="number" style={{ marginBottom: 10 }} fullWidth variant="outlined" />
                                        </StyledTableCell>}

                                        {/* Area for subunit area and Product is false ceiling */}
                                        {(data.subUnitType === 'Area' && falseCeilingValidate(data?.product?.name)) && <StyledTableCell component="th" scope="row">
                                          {(data?.product?.name.toLowerCase().includes('false ceiling')) ? `` :
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  checked={data.customArea}
                                                  onChange={(e) => customArea(i, e, data.customArea)}
                                                  name="customeArea"
                                                  color="primary"
                                                />
                                              }
                                              label="Custom Area"
                                            />}
                                          {!data.customArea ? Number(data?.area).toFixed(2) :
                                            <TextField name="productCustomArea" size="small" value={data?.productCustomArea} onChange={(e) => handleAreaQtyChange(e, i, 'r')} type="number" style={{ marginBottom: 10 }} fullWidth variant="outlined" />
                                          }
                                        </StyledTableCell>}

                                        {/* Area for subunit area and Product is not false ceiling */}
                                        {(data.subUnitType === 'Area' && !falseCeilingValidate(data?.product?.name)) && <StyledTableCell component="th" scope="row">
                                          {data.area}
                                        </StyledTableCell>}

                                        {/* Area for subunit Qty */}
                                        {(data.subUnitType === 'Qty') && <StyledTableCell component="th" scope="row">
                                          <TextField
                                            disabled={
                                              (projectDetails.contractCustomerApproved &&
                                                projectDetails.contractFinanceApproved &&
                                                projectDetails.designStages === 'Design Sign-off') &&
                                              (data?.newItemAdded ? false : true)
                                              ||
                                              data?.product?.name == "Granite - Material + Fixing (Min order quantity 20 sft)"
                                            }
                                            name="area" size="small" value={data?.area} onChange={(e) => handleAreaQtyChange(e, i, 'a')} type="number" style={{ marginBottom: 10 }} fullWidth variant="outlined" />
                                        </StyledTableCell>}

                                        {/* total price of value of any itme */}
                                        <StyledTableCell component="th" scope="row">
                                          ₹ {
                                            (
                                              (data.subUnitType === 'Area' || data.subUnitType === 'Qty') ?
                                                ((
                                                  data.depth < 0 ||
                                                  data.length < 0 ||
                                                  data.width < 0 ||
                                                  data.area < 0 ||
                                                  (data.fixingCharge && data.fixingCharge < 0)
                                                ) ?
                                                  -1 * Math.abs((data.productPrice))
                                                  : (data?.productPrice)
                                                )
                                                :
                                                (data?.productPrice))
                                          }
                                          {data?.product?.name === 'Stone Cladding' && <Typography variant='p'>(Includes fixing cost)</Typography>}
                                        </StyledTableCell>
                                      </StyledTableRow>
                                    )
                                  }
                                  )}

                                  <StyledTableRow >
                                    <StyledTableCell component="th" scope="row" align="right" colSpan={9}></StyledTableCell>
                                    <StyledTableCell component="th" scope="row" align="center">Total</StyledTableCell>
                                    {/* if item is decreasing and progject */}
                                    <StyledTableCell component="th" scope="row">
                                      {/* {console.log("calculation total", projectComponentProducts?.[chosenCategory]?.item)}  */}
                                      ₹ {
                                        projectComponentProducts.hasOwnProperty(chosenCategory) &&
                                          projectComponentProducts?.[chosenCategory]?.item.length === 0
                                          ? '0'
                                          : commaSeparateAmount(
                                            projectComponentProducts.hasOwnProperty(chosenCategory) &&
                                            Math.round(
                                              projectComponentProducts?.[chosenCategory]?.item
                                                // .filter((data) => !['A0', 'A1', 'A2', 'A3', 'A4'].includes(data?.product?.code))
                                                .reduce(
                                                  (acc, curr) => {
                                                    let productPrice;
                                                    // Check if any of length, width, or depth is negative
                                                    if (curr.length < 0 || curr.width < 0 || curr.depth < 0) {
                                                      // Make productPrice negative if any of them is negative
                                                      curr.productPrice = -1 * Math.abs(curr.productPrice);
                                                    }
                                                    // Otherwise, add the current curr.productPrice to acc.productPrice
                                                    productPrice = Number(acc.productPrice) + Number(curr.productPrice);
                                                    return { productPrice };
                                                  },
                                                  { productPrice: 0 } // Initialize the accumulator with productPrice as 0
                                                ).productPrice
                                            )
                                          )
                                      }
                                    </StyledTableCell>
                                  </StyledTableRow>
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </>}
                        </Modal >

                         {/* Preview Quotation Modal */}
                        <Modal
                          title="Preview Quotation"
                          centered
                          visible={openPreviewModal}
                          onCancel={() => {
                            setOpenPreviewModal(false);
                            setComplimentaryItemPresent(false);
                            setComplimentaryItemRevoked(false);
                            setNewComplimentaryItem(false);
                            setRejectedItem(false);
                          }}
                          width={1000}
                          maskClosable={false}
                          footer={null}
                        >
                          <div >
                            <div style={{ float: 'right', marginBottom: 20 }}>
                              <TextField type="number" id="outlined-basic" label="Discount (in %)" size="small" value={discount} onChange={(e) => calDiscount(e.target.value, 'val')} variant="outlined"
                                disabled={
                                  (projectDetails.contractCustomerApproved &&
                                    projectDetails.contractFinanceApproved &&
                                    projectDetails.designStages === 'Design Sign-off')}
                              />
                              {
                                (!(discount <= discountMaster) && (discount !== projectDetails.discountPercent) || (projectDetails.discountStatus === 'Rejected') && !(discount <= discountMaster))
                                  ?
                                  <div>
                                    {discount !== projectDetails.discountPercent && projectDetails.discountStatus !== 'Sent for approval' &&
                                      <div>
                                        <b>Discount cannot be more than {discountMaster}%</b> <br />
                                        <Button variant="contained" color="primary" onClick={() => discountRequest(discount)}>Request</Button>
                                      </div>
                                    }
                                  </div>
                                  :
                                  null
                              }
                              {
                                (discount === projectDetails.discountPercent && projectDetails.discountStatus === 'Approved')
                                  ?
                                  <div>
                                    {/* Take the last key of discount approve log */}
                                    {projectDetails.discountStatus} by {projectDetails.discountLogs[projectDetails.discountLogs.length - 1]['actionTakenBy']?.['name']}
                                  </div>
                                  :
                                  null
                              }
                              {
                                (discount === projectDetails.discountPercent && projectDetails.discountStatus === 'Rejected' && !(discount <= discountMaster))
                                  ?
                                  <div>
                                    {/* Take the last key of discount approve log */}
                                    {projectDetails.discountStatus} by {projectDetails.discountLogs[projectDetails.discountLogs.length - 1]['actionTakenBy']?.['name']}
                                  </div>
                                  :
                                  null
                              }
                              {
                                (projectDetails.discountStatus === 'Sent for approval')
                                  ?
                                  <div>
                                    {projectDetails.discountStatus}
                                    <Button variant="contained" color="primary" onClick={() => revoke()}>Revoke</Button>
                                  </div>
                                  :
                                  null
                              }
                            </div>
                          </div>

                          {(projectDetails.contractCustomerApproved &&
                            projectDetails.contractFinanceApproved &&
                            projectDetails.designStages === 'Design Sign-off') ?
                            qtPreview.filter(data => data.spacename === 'POST DESIGN SIGN-OFF CHANGES').map((data, i) =>
                              <TableContainer key={i + 1} component={Paper} style={{ marginBottom: 20 }}>
                                <div style={{ textAlign: "center", marginBottom: 10, marginTop: 10 }}><b>{data.spacename}</b></div>
                                <Table className={classes.table} size="small" aria-label="customized table">
                                  <TableHead>
                                    <TableRow>
                                      <StyledTableCell>Sl No</StyledTableCell>
                                      <StyledTableCell>Name</StyledTableCell>
                                      <StyledTableCell>Priority</StyledTableCell>
                                      <StyledTableCell>Finish Type</StyledTableCell>
                                      <StyledTableCell>No/Qty</StyledTableCell>
                                      <StyledTableCell>Depth</StyledTableCell>
                                      <StyledTableCell>Width</StyledTableCell>
                                      <StyledTableCell>Length</StyledTableCell>
                                      <StyledTableCell>Area/Qty</StyledTableCell>
                                      <StyledTableCell>Total</StyledTableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data?.product?.filter(item => item?.negativeQtCr || item?.positiveQtCr)?.sort((a, b) => a['priority'] - b['priority']).map((data1, i) =>
                                      <StyledTableRow key={i + 1}>
                                        <StyledTableCell component="th" scope="row">{i + 1}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{data1?.product?.name}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{data1?.priority}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{data1?.product?.finishInclude ? data1?.finishType?.name : `-`}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{data1?.product?.name.includes('TIles fixing charges for tiles') ? data1?.fixingCharge : `-`}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{(data1?.product?.name.includes('False ceiling (Peripheral with Cove') || data1?.product?.name.includes('False ceiling (Peripheral, No Cove')) ? data1?.depth : `-`}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{data1?.product?.name.includes('TIles fixing charges for tiles') || data1?.product?.name.toLowerCase().includes('false ceiling rafter') || data1?.product?.unitType?._id == rftUnitTypeId ? `-` : data1?.width ? data1?.width : `-`}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{data1?.product?.name.includes('TIles fixing charges for tiles') ? `-` : data1?.length ? data1?.length : `-`} </StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{data1?.area ? data1?.area.toFixed(2) : `-`}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(data1?.productPrice)}</StyledTableCell>
                                      </StyledTableRow>
                                    )}
                                    <StyledTableRow>
                                      <StyledTableCell component="th" scope="row" align="right" colSpan={8}></StyledTableCell>
                                      <StyledTableCell component="th" scope="row" align="center">Total</StyledTableCell>
                                      <StyledTableCell component="th" scope="row" align="center">
                                        ₹ {data?.product.length === 0 ? `0` :
                                          commaSeparateAmount(
                                            data?.product
                                              .filter(item => item?.negativeQtCr || item.positiveQtCr)
                                              .reduce((acc, crr) => ({ productPrice: acc.productPrice + crr.productPrice }), { productPrice: 0 }) // Provide an initial value of { productPrice: 0 }
                                              .productPrice
                                          )}
                                      </StyledTableCell>
                                    </StyledTableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            )
                            :
                            qtPreview.map((data, i) =>
                              <TableContainer key={i + 1} component={Paper} style={{ marginBottom: 20 }}>
                                <div style={{ textAlign: "center", marginBottom: 10, marginTop: 10 }}><b>{data.spacename}</b></div>
                                <Table className={classes.table} size="small" aria-label="customized table">
                                  <TableHead>
                                    <TableRow>
                                      <StyledTableCell>Sl No</StyledTableCell>
                                      <StyledTableCell>Name</StyledTableCell>
                                      <StyledTableCell>Priority</StyledTableCell>
                                      <StyledTableCell>Finish Type</StyledTableCell>
                                      <StyledTableCell>No/Qty</StyledTableCell>
                                      <StyledTableCell>Depth</StyledTableCell>
                                      <StyledTableCell>Width</StyledTableCell>
                                      <StyledTableCell>Length</StyledTableCell>
                                      <StyledTableCell>Area/Qty</StyledTableCell>
                                      <StyledTableCell>Total</StyledTableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data?.product?.sort((a, b) => a['priority'] - b['priority']).map((data1, i) =>
                                      <StyledTableRow key={i + 1}>
                                        <StyledTableCell component="th" scope="row">{i + 1}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{data1?.product?.name}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{data1?.priority}</StyledTableCell>
                                        {/* <StyledTableCell >{data1?.product?.scope?.name ? data1?.product?.scope?.name : `-`}</StyledTableCell> */}
                                        <StyledTableCell component="th" scope="row">{data1?.product?.finishInclude ? data1?.finishType?.name : `-`}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{data1?.product?.name.includes('TIles fixing charges for tiles') ? data1?.fixingCharge : `-`}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{(data1?.product?.name.includes('False ceiling (Peripheral with Cove') || data1?.product?.name.includes('False ceiling (Peripheral, No Cove')) ? data1?.depth : `-`}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{data1?.product?.name.includes('TIles fixing charges for tiles') || data1?.product?.name.toLowerCase().includes('false ceiling rafter') || data1?.product?.unitType?._id == rftUnitTypeId ? `-` : data1?.width ? data1?.width : `-`}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{data1?.product?.name.includes('TIles fixing charges for tiles') ? `-` : data1?.length ? data1?.length : `-`} </StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{data1?.area ? data1?.area.toFixed(2) : `-`}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(data1?.productPrice)}</StyledTableCell>
                                      </StyledTableRow>
                                    )}
                                    <StyledTableRow>
                                      <StyledTableCell component="th" scope="row" align="right" colSpan={8}></StyledTableCell>
                                      <StyledTableCell component="th" scope="row" align="center">Total</StyledTableCell>
                                      <StyledTableCell component="th" scope="row" align="center">
                                        ₹ {data?.product.length === 0 ? `0` :
                                          commaSeparateAmount((data?.product?.reduce((acc, crr) => ({ productPrice: acc.productPrice + crr.productPrice }))).productPrice)}
                                      </StyledTableCell>
                                    </StyledTableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            )
                          }

                          {
                            (projectDetails.contractCustomerApproved &&
                              projectDetails.contractFinanceApproved &&
                              projectDetails.designStages === 'Design Sign-off') ?
                              // When negative changes is there
                              (projectDetails.discountOnAllScopes === true ?

                                <div>
                                  <TableContainer component={Paper} style={{ marginBottom: 20 }}>
                                    <Table>
                                      <TableBody>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>Total Quotation value</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(newChangesTotalProductsPrice.totalQuotationValue)}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>Discount @ {paymentTotalInfo.discountPercent} %</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(newChangesTotalProductsPrice.discount)}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>Sub Total</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(newChangesTotalProductsPrice.subTotal)}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>GST @ 18%</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(newChangesTotalProductsPrice.gst18PerAmount)}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>Total</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">
                                            {projectDetails?.sentForQuotationChangeApproval?.onlyQuotationAmount ?
                                              `₹ ${commaSeparateAmount(projectDetails?.sentForQuotationChangeApproval?.onlyQuotationAmount)}` :
                                              `₹ ${commaSeparateAmount(newChangesTotalProductsPrice.total)}`
                                            }
                                          </StyledTableCell>
                                        </StyledTableRow>
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </div>
                                :
                                <div>
                                  <TableContainer component={Paper} style={{ marginBottom: 20 }}>
                                    <Table>
                                      <TableBody>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>Total Value ({eligibleDiscountScopes})</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(totalDescPerAmt)}</StyledTableCell>
                                          {/* <StyledTableCell component="th" scope="row">{paymentTotalInfo.priceAmount}</StyledTableCell> */}
                                        </StyledTableRow>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>Discount @ {paymentTotalInfo.discountPercent} %</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(paymentTotalInfo.discountValue)}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>Discounted Value ({eligibleDiscountScopes})</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(paymentTotalInfo.discItemsSubTotal)}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>Other Items ({eligibleNonDiscountScopes})</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(paymentTotalInfo.totalNonDiscPrAmnt)}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>Total</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(paymentTotalInfo.subTotal)}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>GST @ 18%</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(paymentTotalInfo.taxableAmount)}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>Overall Price</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(paymentTotalInfo.total)}</StyledTableCell>
                                        </StyledTableRow>
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </div>
                              )
                              :
                              // When not negative positive quotation changes
                              (projectDetails.discountOnAllScopes === true
                                ?
                                <div>
                                  <TableContainer component={Paper} style={{ marginBottom: 20 }}>
                                    <Table>
                                      <TableBody>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>Total Quotation value</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(paymentTotalInfo.priceAmount)}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>Discount @ {paymentTotalInfo.discountPercent} %</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(paymentTotalInfo.discountValue)}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>Sub Total</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(paymentTotalInfo.subTotal)}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>GST @ 18%</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(paymentTotalInfo.taxableAmount)}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>Total</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(paymentTotalInfo.total)}</StyledTableCell>
                                        </StyledTableRow>
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </div>
                                :
                                <div>
                                  <TableContainer component={Paper} style={{ marginBottom: 20 }}>
                                    <Table>
                                      <TableBody>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>Total Value ({eligibleDiscountScopes})</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(totalDescPerAmt)}</StyledTableCell>
                                          {/* <StyledTableCell component="th" scope="row">{paymentTotalInfo.priceAmount}</StyledTableCell> */}
                                        </StyledTableRow>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>Discount @ {paymentTotalInfo.discountPercent} %</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(paymentTotalInfo.discountValue)}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>Discounted Value ({eligibleDiscountScopes})</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(paymentTotalInfo.discItemsSubTotal)}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>Other Items ({eligibleNonDiscountScopes})</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(paymentTotalInfo.totalNonDiscPrAmnt)}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>Total</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(paymentTotalInfo.subTotal)}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>GST @ 18%</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(paymentTotalInfo.taxableAmount)}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                          <StyledTableCell component="th" scope="row"><b>Overall Price</b></StyledTableCell>
                                          <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(paymentTotalInfo.total)}</StyledTableCell>
                                        </StyledTableRow>
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </div>
                              )
                            // :
                            // null
                          }
                          {/* Add category delay penality , damages and referral bonus */}
                          <div>
                            {(projectDetails.contractCustomerApproved && projectDetails.contractFinanceApproved && projectDetails.designStages === 'Design Sign-off') && (
                              <div>
                                <TableContainer component={Paper} style={{ marginBottom: 20 }}>
                                  <Table>
                                    <TableBody>
                                      <StyledTableRow>
                                        <StyledTableCell component="th" scope="row">
                                          <Checkbox onChange={(e) => handleCheckBox('Delay Penality')} checked={damageDelayOtherValue.delayPenalityCheck} disabled={projectDetails?.sentForQuotationChangeApproval?.isSendForApproval} />
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row"><b>Delay Penality</b></StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          <TextField type="number"
                                            id="delayPenality"
                                            label="Delay Penality"
                                            size="small"
                                            value={damageDelayOtherValue.delayPenality}
                                            onChange={(e) => calculateDamageDelayOtherValue(e.target.value, 'Delay Penality')}
                                            variant="outlined"
                                            disabled={!damageDelayOtherValue.delayPenalityCheck || projectDetails?.sentForQuotationChangeApproval?.isSendForApproval}
                                          />
                                        </StyledTableCell>
                                      </StyledTableRow>

                                      <StyledTableRow>
                                        <StyledTableCell component="th" scope="row">
                                          <Checkbox onChange={(e) => handleCheckBox('Damages')} checked={damageDelayOtherValue.damagesCheck} disabled={projectDetails?.sentForQuotationChangeApproval?.isSendForApproval} />
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row"><b>Damages</b></StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          <TextField type="number"
                                            id="damages"
                                            label="Damages"
                                            size="small"
                                            value={damageDelayOtherValue.damages}
                                            onChange={(e) => calculateDamageDelayOtherValue(e.target.value, 'Damages')}
                                            variant="outlined"
                                            disabled={!damageDelayOtherValue.damagesCheck || projectDetails?.sentForQuotationChangeApproval?.isSendForApproval}
                                          />
                                        </StyledTableCell>
                                      </StyledTableRow>

                                      <StyledTableRow>
                                        <StyledTableCell component="th" scope="row">
                                          <Checkbox onChange={(e) => handleCheckBox('Good Will Discount')} checked={damageDelayOtherValue.goodWillDiscountCheck} disabled={projectDetails?.sentForQuotationChangeApproval?.isSendForApproval} />
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row"><b>Good Will Discount</b></StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          <TextField type="number"
                                            id="goodWillDiscount"
                                            label="Good Will Discount"
                                            size="small"
                                            value={damageDelayOtherValue.goodWillDiscount}
                                            onChange={(e) => calculateDamageDelayOtherValue(e.target.value, 'Good Will Discount')}
                                            variant="outlined"
                                            disabled={!damageDelayOtherValue.goodWillDiscountCheck || projectDetails?.sentForQuotationChangeApproval?.isSendForApproval}
                                          />
                                        </StyledTableCell>
                                      </StyledTableRow>

                                      <StyledTableRow>
                                        <StyledTableCell component="th" scope="row">
                                          <Checkbox onChange={(e) => handleCheckBox('Other')} checked={damageDelayOtherValue.otherCheck} disabled={projectDetails?.sentForQuotationChangeApproval?.isSendForApproval} />
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row"><b>Other</b></StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          <TextField type="number"
                                            id="other"
                                            label="Other"
                                            size="small"
                                            value={damageDelayOtherValue.other}
                                            onChange={(e) => calculateDamageDelayOtherValue(e.target.value, 'Other')}
                                            variant="outlined"
                                            disabled={!damageDelayOtherValue.otherCheck || projectDetails?.sentForQuotationChangeApproval?.isSendForApproval}
                                          />
                                        </StyledTableCell>
                                      </StyledTableRow>

                                      {/* <StyledTableRow>
                                        <StyledTableCell component="th" scope="row">
                                          <Checkbox onChange={(e) => handleCheckBox('Referral Bonus')} checked={damageDelayOtherValue.referralBonusCheck} disabled={projectDetails?.sentForQuotationChangeApproval?.isSendForApproval} />
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row"><b>Referral Bonus</b></StyledTableCell>
                                        <StyledTableCell component="th" scope="row">
                                          <TextField type="number"
                                            id="referralBonus"
                                            label="Referral Bonus"
                                            size="small"
                                            value={damageDelayOtherValue.referralBonus}
                                            onChange={(e) => calculateDamageDelayOtherValue(e.target.value, 'Referral Bonus')}
                                            variant="outlined"
                                            disabled={!damageDelayOtherValue.referralBonusCheck || projectDetails?.sentForQuotationChangeApproval?.isSendForApproval}
                                          />
                                        </StyledTableCell>
                                      </StyledTableRow> */}

                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </div>
                            )}
                          </div>

                          {/* Balance Statment is here */}
                          {(projectDetails.contractCustomerApproved && projectDetails.contractFinanceApproved && projectDetails.designStages === 'Design Sign-off') && (
                            <div>
                              <h2>Balance Sheet</h2>
                              <TableContainer component={Paper} style={{ marginBottom: 20 }}>
                                <Table>
                                  <TableBody>
                                    <StyledTableRow>
                                      <StyledTableCell component="th" scope="row" colspan={3}><h3>{"Project No." + " " + projectDetails.erpProjectNo}</h3></StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                      <StyledTableCell component="th" scope="row"></StyledTableCell>
                                      <StyledTableCell component="th" scope="row"><b>Quotation value</b></StyledTableCell>
                                      <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(quotationTotalAmount)}</StyledTableCell>
                                    </StyledTableRow>
                                    {
                                      projectDetails.contractCustomerApproved && projectDetails.contractFinanceApproved && projectDetails.designStages === 'Design Sign-off' &&
                                      qtPreview.filter(data => data.spacename === 'POST DESIGN SIGN-OFF CHANGES').map((data, i) => {
                                        return (
                                          data.product.map((productItem, index) => (
                                            (productItem?.negativeQtCr || productItem?.positiveQtCr) &&
                                            (
                                              <StyledTableRow key={`${i}-${index}`}>
                                                <StyledTableCell component="th" scope="row">{productItem?.positiveQtCr ? "Add" : (productItem?.negativeQtCr ? "Less" : null)}</StyledTableCell>
                                                <StyledTableCell component="th" scope="row">{productItem?.product.name}</StyledTableCell>
                                                <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(productItem.productPrice)}</StyledTableCell>
                                              </StyledTableRow>
                                            )
                                          ))
                                        )
                                      })
                                    }
                                    <StyledTableRow>
                                      <StyledTableCell component="th" scope="row"></StyledTableCell>
                                      <StyledTableCell component="th" scope="row"><b>Revise Quotation Value</b></StyledTableCell>
                                      <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(balanceSheetData.reviseQuotationValue)}</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                      <StyledTableCell component="th" scope="row">Less:</StyledTableCell>
                                      <StyledTableCell component="th" scope="row">Discount @ {paymentTotalInfo.discountPercent}%</StyledTableCell>
                                      <StyledTableCell component="th" scope="row">₹ {transform(balanceSheetData.discount)}</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                      <StyledTableCell component="th" scope="row"></StyledTableCell>
                                      <StyledTableCell component="th" scope="row"><b>SubTotal</b></StyledTableCell>
                                      <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(balanceSheetData.subTotal)}</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                      <StyledTableCell component="th" scope="row"></StyledTableCell>
                                      <StyledTableCell component="th" scope="row">GST @ 18%</StyledTableCell>
                                      <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(balanceSheetData.GST)}</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                      <StyledTableCell component="th" scope="row"></StyledTableCell>
                                      <StyledTableCell component="th" scope="row"><b>Total</b></StyledTableCell>
                                      <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(balanceSheetData.total)}</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                      <StyledTableCell component="th" scope="row"></StyledTableCell>
                                      <StyledTableCell component="th" scope="row">Amount Paid</StyledTableCell>
                                      <StyledTableCell component="th" scope="row">
                                        <TextField
                                          type="number"
                                          id="amountPaid"
                                          size="small"
                                          value={amountPaid}
                                          onChange={(e) => handleAmountPaid(e.target.value)}
                                          variant="standard"
                                          disabled={projectDetails?.sentForQuotationChangeApproval?.isSendForApproval}
                                          style={{ width: "150px", fontSize: '10px' }}
                                        />
                                      </StyledTableCell>
                                    </StyledTableRow>
                                    {
                                      Object.entries(damageDelayOtherValue).map(([key, value]) => {
                                        // Check if the key represents a check and if its corresponding value is true
                                        if (key.endsWith('Check') && value) {
                                          const fieldName = key.slice(0, -5);
                                          const capitalizedFieldName = fieldName
                                            .replace(/([A-Z])/g, ' $1') // Insert space before each uppercase letter
                                            .replace(/^./, (match) => match.toUpperCase()) // Capitalize the first character
                                            .trim(); // Trim any leading/trailing spaces
                                          return (
                                            <StyledTableRow key={key}>
                                              <StyledTableCell component="th" scope="row">Less</StyledTableCell>
                                              <StyledTableCell component="th" scope="row"><b>{capitalizedFieldName}</b></StyledTableCell>
                                              <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(damageDelayOtherValue[fieldName])}</StyledTableCell>
                                            </StyledTableRow>
                                          );
                                        }
                                        return null; // If the check field is false or if it's not a check field, return null
                                      })
                                    }
                                    <StyledTableRow>
                                      <StyledTableCell component="th" scope="row"></StyledTableCell>
                                      <StyledTableCell component="th" scope="row"><b>Pending Due</b></StyledTableCell>
                                      <StyledTableCell component="th" scope="row">₹ {commaSeparateAmount(parseInt(balanceSheetData.pendingDue))}</StyledTableCell>
                                    </StyledTableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          )}

                          <div>
                            {(projectDetails.contractCustomerApproved && projectDetails.contractFinanceApproved && projectDetails.designStages === 'Design Sign-off') ?
                              ((projectDetails?.sentForQuotationChangeApproval?.FinanceManagerApproval === 'Approved' && projectDetails?.sentForQuotationChangeApproval?.OperationHeadApproval === 'Approved' && finalizeButtonVisibility) ?
                                <Button variant="contained" color="primary" style={{ float: "right" }}
                                  onClick={() => finalize()}
                                  disabled={projectDetails.complimentaryItemStatus === "Sent for Approval"}>
                                  Finalize quotation
                                </Button>
                                :
                                (projectDetails?.sentForQuotationChangeApproval?.OperationHeadApproval === 'Approved') ?
                                  <Button variant="contained" color="primary" style={{ float: "right" }}
                                    onClick={() => finalize()}
                                    disabled={projectDetails.complimentaryItemStatus === "Sent for Approval"}>
                                    Finalize quotation
                                  </Button>
                                  :
                                  <div>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        gap: "5px",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Button onClick={() => setPaymentReceiptModal(true)}
                                        variant="contained"
                                        color="primary"
                                        disabled={projectDetails?.sentForQuotationChangeApproval?.isSendForApproval || uploadPaymentButtonVisibility}>
                                        Upload Payment Receipt
                                      </Button>
                                      {/* Download and delete button  */}
                                      <div style={{ marginTop: '5px' }}>
                                        <b>View Payment Receipt: </b>
                                        {
                                          projectDetails?.sentForQuotationChangeApproval?.paymentReceiptArray?.map((row, index) => (
                                            <span key={index}>
                                              <DownloadOutlined
                                                onClick={() => window.open(row)}
                                                style={{ color: "green", cursor: "pointer", fontWeight: "bold", fontSize: '24px' }}
                                              />
                                            </span>
                                          ))
                                        }
                                      </div>
                                      <Dialog open={paymentReceiptModal} onClose={() => setPaymentReceiptModal(false)} aria-labelledby="form-dialog-title" maxWidth='sm'>
                                        <DialogTitle style={{ fontSize: "10px" }} id="form-dialog-title">Please Upload Payment Receipt(s) for this quotation</DialogTitle>
                                        <Divider />
                                        <DialogContent>
                                          <span>
                                            <ul style={{ fontSize: "15px", lineHeight: '1.6rem', display: displayUploadReceiptMsg ? 'block' : 'none' }}>
                                              {/* <li><span style={{color: "red"}}>For Negative Change Values:</span> Please upload <b>existing payment receipt(s)</b>.</li> */}
                                              <li><span style={{ color: "green" }}>For Positive Change Values:</span> Please share <b> this quotation screenshots with customer </b>and upload receipt(s) after payment along with existing reciept(s).</li>
                                            </ul>
                                          </span>
                                          <div>
                                            <FormControl>
                                              <>
                                                <input
                                                  accept=".jpg, .jpeg, .png, .pdf"
                                                  className={classes.input}
                                                  id="contained-button-customer"
                                                  disabled={projectDetails?.sentForQuotationChangeApproval?.isSendForApproval}
                                                  type="file"
                                                  multiple
                                                  onChange={paymentUploadFile}
                                                  style={{ display: 'none' }}
                                                  name="view_payment_receipt"
                                                />
                                                <label htmlFor="contained-button-customer" style={{ marginLeft: 5 }}>
                                                  <Button variant="contained" color="primary"
                                                    disabled={projectDetails?.sentForQuotationChangeApproval?.isSendForApproval}
                                                    component="span">
                                                    Upload multiple payment Receipt
                                                  </Button>
                                                  {addPaymentReceiptFileUploaded && <CheckCircleIcon style={{ fontSize: '24px', fontWeight: 'bold', color: "green" }} />}
                                                </label>
                                              </>
                                            </FormControl>
                                            {/* Download and and download delete button  */}
                                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                              {paymentReceiptArray.map((data, i) => {
                                                return (
                                                  <div
                                                    key={i}
                                                    style={{
                                                      display: "flex",
                                                      flexDirection: "row",
                                                      gap: "10px",
                                                      alignItems: "center",
                                                      // marginBottom: "20px",
                                                    }}
                                                  >
                                                    <span>
                                                      <DownloadOutlined
                                                        onClick={() => window.open(data)}
                                                        style={{ color: "green", cursor: "pointer", fontWeight: "bold", fontSize: '24px' }}
                                                      />
                                                      <DeleteOutlineOutlinedIcon
                                                        onClick={() => handleDelete(i)}
                                                        style={{ color: "red", cursor: "pointer" }}
                                                      />
                                                    </span>
                                                  </div>
                                                );
                                              })}
                                            </div>
                                          </div>
                                        </DialogContent>
                                        <Divider />
                                        <DialogActions>
                                          <Button onClick={() => setPaymentReceiptModal(false)} variant="outlined" color="secondary">
                                            Cancel
                                          </Button>
                                        </DialogActions>
                                      </Dialog>
                                      {/* send for Approval Button */}
                                      <Button variant="contained" color="primary" style={{ float: "right" }}
                                        onClick={() => sendForApproval()}
                                        disabled={
                                          projectDetails?.sentForQuotationChangeApproval?.isSendForApproval || (sendForApprovalDisable && !sendForApprovalDisable) ||
                                          (sendForApprovalDisable && (!paymentReceipt || paymentReceiptArray.length <= 0))
                                        } >
                                        Send for approval
                                      </Button>
                                    </div>
                                  </div>
                              )
                              :
                              <Button variant="contained" color="primary" style={{ float: "right" }}
                                onClick={() => finalize()}
                                disabled={projectDetails.complimentaryItemStatus === "Sent for Approval"}>
                                Finalize quotation
                              </Button>
                            }
                          </div>
                          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <div style={{ display: "flex", gap: '10px' }}>
                              {projectDetails.contractCustomerApproved &&
                                projectDetails.contractFinanceApproved &&
                                projectDetails.designStages === 'Design Sign-off' && projectDetails?.sentForQuotationChangeApproval?.isSendForApproval && !projectDetails?.isChmUser && (
                                  <>

                                    <h4
                                      style={{
                                        color: projectDetails?.sentForQuotationChangeApproval?.DesignManagerApproval === 'Sent for Approval' ? 'red'
                                          : projectDetails?.sentForQuotationChangeApproval?.DesignManagerApproval === 'Approved' ? 'green' : 'inherit'
                                      }}> DM/ADM <FaArrowRight />
                                    </h4>

                                    <h4 style={{
                                      color: projectDetails?.sentForQuotationChangeApproval?.OpsDesignApproval === 'Sent for Approval' ? 'red'
                                        : projectDetails?.sentForQuotationChangeApproval?.OpsDesignApproval === 'Approved' ? 'green' : 'inherit'
                                    }}> Operation DM <FaArrowRight /></h4>


                                    {projectDetails?.sentForQuotationChangeApproval?.checkQtCrAmount?.allPositiveValues !== true ?
                                      (
                                        <h4 style={{
                                          color: projectDetails?.sentForQuotationChangeApproval?.DgmOpsApproval === 'Sent for Approval' ? 'red'
                                            : projectDetails?.sentForQuotationChangeApproval?.DgmOpsApproval === 'Approved' ? 'green' : 'inherit'
                                        }}> DGM Ops <FaArrowRight /></h4>
                                      ) : null}


                                    <h4 style={{
                                      color: projectDetails?.sentForQuotationChangeApproval?.FinanceManagerApproval === 'Sent for Approval' ? 'red'
                                        : projectDetails?.sentForQuotationChangeApproval?.FinanceManagerApproval === 'Approved' ? 'green' : 'inherit'
                                    }}> Finance Manager <FaArrowRight /></h4>


                                    {projectDetails?.sentForQuotationChangeApproval?.checkQtCrAmount?.valuesGreaterThan20k === true ||
                                      projectDetails?.delayCategoryCheck === true ? (
                                      <h4 style={{
                                        color: projectDetails?.sentForQuotationChangeApproval?.OperationHeadApproval === 'Sent for Approval' ? 'red'
                                          : projectDetails?.sentForQuotationChangeApproval?.OperationHeadApproval === 'Approved' ? 'green' : 'inherit'
                                      }}> Director Approval </h4>
                                    ) : null}
                                  </>
                                )}

                                {/* this is for CHM approval tracker only */}
                                {projectDetails?.isChmUser &&
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px'}}>          
                                        <h5 style={{
                                            color: projectDetails?.sentForQuotationChangeApproval?.DgmOpsApproval === 'Sent for Approval' ? 'red'
                                            : projectDetails?.sentForQuotationChangeApproval?.DgmOpsApproval === 'Approved' ? 'green' : 'inherit'
                                        }}> DGM Ops <FaArrowRight /></h5>
                                        <h5 style={{
                                            color: projectDetails?.sentForQuotationChangeApproval?.FinanceManagerApproval === 'Sent for Approval' ? 'red'
                                                : projectDetails?.sentForQuotationChangeApproval?.FinanceManagerApproval === 'Approved' ? 'green' : 'inherit'
                                        }}> Finance Manager <FaArrowRight />
                                        </h5>
                                    
                                        <h5 style={{
                                            color: projectDetails?.sentForQuotationChangeApproval?.OperationHeadApproval === 'Sent for Approval' ? 'red'
                                                : projectDetails?.sentForQuotationChangeApproval?.OperationHeadApproval === 'Approved' ? 'green' : 'inherit'
                                        }}> Director Approval </h5>
                                    </div>
                                }
                                {/* this is for CHM approval tracker only */}
                            </div>
                          </div>
                        </Modal>

                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      
    </div>
  );
};
export default connect(null, { setUserDetails, setLoading, setSnackInfo })(
  RaiseQuotationChangeRequest
);